/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface AgentService {
  /** @summary Get Default */
  getDefaultVoiceAgent: {
    /** @summary Get Default */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetDefaultVoiceAgentParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetDefaultVoiceAgentSchema,
        options: {
          parameters: GetDefaultVoiceAgentParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>
    ): Promise<RequestFnResponse<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>;
    /** @summary Get Default */
    getQueryKey(
      parameters: DeepReadonly<GetDefaultVoiceAgentParameters> | void
    ): ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.getDefaultVoiceAgent.useQuery()
     * ```
     */
    useQuery<TData = GetDefaultVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.getDefaultVoiceAgent.useQuery()
     * ```
     */
    useQuery<TData = GetDefaultVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /** @summary Get Default */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetDefaultVoiceAgentParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.getDefaultVoiceAgent.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDefaultVoiceAgentParameters,
      TQueryFnData = GetDefaultVoiceAgentData,
      TData = OperationInfiniteData<TQueryFnData, GetDefaultVoiceAgentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.getDefaultVoiceAgent.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDefaultVoiceAgentParameters,
      TQueryFnData = GetDefaultVoiceAgentData,
      TData = OperationInfiniteData<TQueryFnData, GetDefaultVoiceAgentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetDefaultVoiceAgentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getDefaultVoiceAgentTotal = qraft.agentService.getDefaultVoiceAgent.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getDefaultVoiceAgentResults = qraft.agentService.getDefaultVoiceAgent.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getDefaultVoiceAgentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getDefaultVoiceAgentCombinedResults = qraft.agentService.getDefaultVoiceAgent.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getDefaultVoiceAgentCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetDefaultVoiceAgentSchema,
          GetDefaultVoiceAgentParameters,
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentService.getDefaultVoiceAgent.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetDefaultVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.getDefaultVoiceAgent.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetDefaultVoiceAgentParameters, TData = GetDefaultVoiceAgentData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError,
          OperationInfiniteData<TData, GetDefaultVoiceAgentParameters>,
          ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetDefaultVoiceAgentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetDefaultVoiceAgentParameters>,
      OperationError<GetDefaultVoiceAgentError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getDefaultVoiceAgentData = qraft.agentService.getDefaultVoiceAgent.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getDefaultVoiceAgentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getDefaultVoiceAgentCombinedData = qraft.agentService.getDefaultVoiceAgent.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getDefaultVoiceAgentCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetDefaultVoiceAgentSchema,
          GetDefaultVoiceAgentParameters,
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Default */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<GetDefaultVoiceAgentData>;
    /** @summary Get Default */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<void>;
    /** @summary Get Default */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<GetDefaultVoiceAgentData>;
    /** @summary Get Default */
    fetchInfiniteQuery<TPageParam extends GetDefaultVoiceAgentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>>;
    /** @summary Get Default */
    prefetchInfiniteQuery<TPageParam extends GetDefaultVoiceAgentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<void>;
    /** @summary Get Default */
    ensureInfiniteQueryData<TPageParam extends GetDefaultVoiceAgentParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>>;
    /** @summary Get Default */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void)
    ): GetDefaultVoiceAgentData | undefined;
    /** @summary Get Default */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void)
    ): OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters> | undefined;
    /** @summary Get Default */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
            data: NoInfer<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
            data: GetDefaultVoiceAgentData | undefined,
          ]
        >;
    /** @summary Get Default */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void)
    ): QueryState<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError> | undefined;
    /** @summary Get Default */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetDefaultVoiceAgentParameters>
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>,
          GetDefaultVoiceAgentError
        >
      | undefined;
    /** @summary Get Default */
    setQueryData(
      parameters:
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | undefined)
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
      updater: Updater<
        NoInfer<GetDefaultVoiceAgentData> | undefined,
        NoInfer<DeepReadonly<GetDefaultVoiceAgentData>> | undefined
      >,
      options?: SetDataOptions
    ): GetDefaultVoiceAgentData | undefined;
    /** @summary Get Default */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters> | undefined;
    /** @summary Get Default */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >,
      updater: Updater<NoInfer<GetDefaultVoiceAgentData> | undefined, NoInfer<GetDefaultVoiceAgentData> | undefined>,
      options?: SetDataOptions
    ): Array<GetDefaultVoiceAgentData | undefined>;
    /** @summary Get Default */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        TInfinite,
        GetDefaultVoiceAgentParameters,
        GetDefaultVoiceAgentError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Default */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Default */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Default */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
    ): void;
    /** @summary Get Default */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Default */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
    ): number;
    schema: GetDefaultVoiceAgentSchema;
    types: {
      parameters: GetDefaultVoiceAgentParameters;
      data: GetDefaultVoiceAgentData;
      error: GetDefaultVoiceAgentError;
    };
  };
  /** @summary Create Default */
  createDefaultVoiceAgent: {
    /** @summary Create Default */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateDefaultVoiceAgentBody,
        CreateDefaultVoiceAgentParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateDefaultVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<
          CreateDefaultVoiceAgentBody,
          CreateDefaultVoiceAgentParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateDefaultVoiceAgentData, CreateDefaultVoiceAgentError>>
    ): Promise<RequestFnResponse<CreateDefaultVoiceAgentData, CreateDefaultVoiceAgentError>>;
    /** @summary Create Default */
    getMutationKey(
      parameters: DeepReadonly<CreateDefaultVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<CreateDefaultVoiceAgentSchema, CreateDefaultVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createDefaultVoiceAgent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createDefaultVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateDefaultVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<CreateDefaultVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateDefaultVoiceAgentSchema,
        CreateDefaultVoiceAgentData,
        CreateDefaultVoiceAgentParameters,
        TVariables,
        OperationError<CreateDefaultVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<
      CreateDefaultVoiceAgentData,
      OperationError<CreateDefaultVoiceAgentError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createDefaultVoiceAgent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createDefaultVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateDefaultVoiceAgentSchema,
        CreateDefaultVoiceAgentData,
        CreateDefaultVoiceAgentParameters,
        TVariables,
        OperationError<CreateDefaultVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<
      CreateDefaultVoiceAgentData,
      OperationError<CreateDefaultVoiceAgentError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createDefaultVoiceAgentTotal = qraft.agentService.createDefaultVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createDefaultVoiceAgentTotal = qraft.agentService.createDefaultVoiceAgent.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateDefaultVoiceAgentSchema,
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createDefaultVoiceAgentPendingMutationVariables = qraft.agentService.createDefaultVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createDefaultVoiceAgentMutationData = qraft.agentService.createDefaultVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateDefaultVoiceAgentData,
        OperationError<CreateDefaultVoiceAgentError>,
        MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateDefaultVoiceAgentSchema,
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateDefaultVoiceAgentData,
          OperationError<CreateDefaultVoiceAgentError>,
          MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create Default */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateDefaultVoiceAgentSchema,
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.createDefaultVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.createDefaultVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateDefaultVoiceAgentBody,
              CreateDefaultVoiceAgentData,
              CreateDefaultVoiceAgentParameters,
              OperationError<CreateDefaultVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateDefaultVoiceAgentSchema,
              CreateDefaultVoiceAgentBody,
              CreateDefaultVoiceAgentData,
              CreateDefaultVoiceAgentParameters,
              OperationError<CreateDefaultVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentError,
            MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateDefaultVoiceAgentBody,
              CreateDefaultVoiceAgentData,
              CreateDefaultVoiceAgentParameters,
              OperationError<CreateDefaultVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateDefaultVoiceAgentSchema,
              CreateDefaultVoiceAgentBody,
              CreateDefaultVoiceAgentData,
              CreateDefaultVoiceAgentParameters,
              OperationError<CreateDefaultVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateDefaultVoiceAgentData,
          CreateDefaultVoiceAgentError,
          MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: CreateDefaultVoiceAgentSchema;
    types: {
      parameters: CreateDefaultVoiceAgentParameters;
      data: CreateDefaultVoiceAgentData;
      error: CreateDefaultVoiceAgentError;
      body: CreateDefaultVoiceAgentBody;
    };
  };
  /** @summary List Voice Agents */
  listVoiceAgents: {
    /** @summary List Voice Agents */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListVoiceAgentsParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListVoiceAgentsSchema,
        options: {
          parameters: ListVoiceAgentsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListVoiceAgentsData, ListVoiceAgentsError>>
    ): Promise<RequestFnResponse<ListVoiceAgentsData, ListVoiceAgentsError>>;
    /** @summary List Voice Agents */
    getQueryKey(
      parameters: DeepReadonly<ListVoiceAgentsParameters> | void
    ): ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.listVoiceAgents.useQuery()
     * ```
     */
    useQuery<TData = ListVoiceAgentsData>(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListVoiceAgentsData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.listVoiceAgents.useQuery()
     * ```
     */
    useQuery<TData = ListVoiceAgentsData>(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListVoiceAgentsData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /** @summary List Voice Agents */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListVoiceAgentsParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listVoiceAgents.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListVoiceAgentsParameters,
      TQueryFnData = ListVoiceAgentsData,
      TData = OperationInfiniteData<TQueryFnData, ListVoiceAgentsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listVoiceAgents.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListVoiceAgentsParameters,
      TQueryFnData = ListVoiceAgentsData,
      TData = OperationInfiniteData<TQueryFnData, ListVoiceAgentsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListVoiceAgentsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listVoiceAgentsTotal = qraft.agentService.listVoiceAgents.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listVoiceAgentsResults = qraft.agentService.listVoiceAgents.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoiceAgentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listVoiceAgentsCombinedResults = qraft.agentService.listVoiceAgents.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoiceAgentsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListVoiceAgentsSchema,
          ListVoiceAgentsParameters,
          ListVoiceAgentsData,
          ListVoiceAgentsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListVoiceAgentsData, ListVoiceAgentsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListVoiceAgentsData, ListVoiceAgentsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentService.listVoiceAgents.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListVoiceAgentsData>(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListVoiceAgentsData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listVoiceAgents.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListVoiceAgentsParameters, TData = ListVoiceAgentsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListVoiceAgentsData,
          ListVoiceAgentsError,
          OperationInfiniteData<TData, ListVoiceAgentsParameters>,
          ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListVoiceAgentsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListVoiceAgentsParameters>,
      OperationError<ListVoiceAgentsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listVoiceAgentsData = qraft.agentService.listVoiceAgents.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoiceAgentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listVoiceAgentsCombinedData = qraft.agentService.listVoiceAgents.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoiceAgentsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListVoiceAgentsSchema,
          ListVoiceAgentsParameters,
          ListVoiceAgentsData,
          ListVoiceAgentsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListVoiceAgentsData, ListVoiceAgentsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListVoiceAgentsData, ListVoiceAgentsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Voice Agents */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        ListVoiceAgentsError
      > | void
    ): Promise<ListVoiceAgentsData>;
    /** @summary List Voice Agents */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        ListVoiceAgentsError
      > | void
    ): Promise<void>;
    /** @summary List Voice Agents */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        ListVoiceAgentsError
      > | void
    ): Promise<ListVoiceAgentsData>;
    /** @summary List Voice Agents */
    fetchInfiniteQuery<TPageParam extends ListVoiceAgentsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        DeepReadonly<TPageParam>,
        ListVoiceAgentsError
      > | void
    ): Promise<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>>;
    /** @summary List Voice Agents */
    prefetchInfiniteQuery<TPageParam extends ListVoiceAgentsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        DeepReadonly<TPageParam>,
        ListVoiceAgentsError
      > | void
    ): Promise<void>;
    /** @summary List Voice Agents */
    ensureInfiniteQueryData<TPageParam extends ListVoiceAgentsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        DeepReadonly<TPageParam>,
        ListVoiceAgentsError
      > | void
    ): Promise<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>>;
    /** @summary List Voice Agents */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void)
    ): ListVoiceAgentsData | undefined;
    /** @summary List Voice Agents */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void)
    ): OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters> | undefined;
    /** @summary List Voice Agents */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
            data: NoInfer<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
            data: ListVoiceAgentsData | undefined,
          ]
        >;
    /** @summary List Voice Agents */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void)
    ): QueryState<ListVoiceAgentsData, ListVoiceAgentsError> | undefined;
    /** @summary List Voice Agents */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListVoiceAgentsParameters>
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>, ListVoiceAgentsError>
      | undefined;
    /** @summary List Voice Agents */
    setQueryData(
      parameters:
        | (DeepReadonly<ListVoiceAgentsParameters> | undefined)
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
      updater: Updater<
        NoInfer<ListVoiceAgentsData> | undefined,
        NoInfer<DeepReadonly<ListVoiceAgentsData>> | undefined
      >,
      options?: SetDataOptions
    ): ListVoiceAgentsData | undefined;
    /** @summary List Voice Agents */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListVoiceAgentsParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters> | undefined;
    /** @summary List Voice Agents */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >,
      updater: Updater<NoInfer<ListVoiceAgentsData> | undefined, NoInfer<ListVoiceAgentsData> | undefined>,
      options?: SetDataOptions
    ): Array<ListVoiceAgentsData | undefined>;
    /** @summary List Voice Agents */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        TInfinite,
        ListVoiceAgentsParameters,
        ListVoiceAgentsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Voice Agents */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Voice Agents */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Voice Agents */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
    ): void;
    /** @summary List Voice Agents */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Voice Agents */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
    ): number;
    schema: ListVoiceAgentsSchema;
    types: {
      parameters: ListVoiceAgentsParameters;
      data: ListVoiceAgentsData;
      error: ListVoiceAgentsError;
    };
  };
  /** @summary Create */
  createVoiceAgent: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateVoiceAgentBody, CreateVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: CreateVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<CreateVoiceAgentBody, CreateVoiceAgentParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateVoiceAgentData, CreateVoiceAgentError>>
    ): Promise<RequestFnResponse<CreateVoiceAgentData, CreateVoiceAgentError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<CreateVoiceAgentSchema, CreateVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createVoiceAgent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<CreateVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateVoiceAgentSchema,
        CreateVoiceAgentData,
        CreateVoiceAgentParameters,
        TVariables,
        OperationError<CreateVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<CreateVoiceAgentData, OperationError<CreateVoiceAgentError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createVoiceAgent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateVoiceAgentSchema,
        CreateVoiceAgentData,
        CreateVoiceAgentParameters,
        TVariables,
        OperationError<CreateVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<CreateVoiceAgentData, OperationError<CreateVoiceAgentError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createVoiceAgentTotal = qraft.agentService.createVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createVoiceAgentTotal = qraft.agentService.createVoiceAgent.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateVoiceAgentSchema,
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createVoiceAgentPendingMutationVariables = qraft.agentService.createVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createVoiceAgentMutationData = qraft.agentService.createVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateVoiceAgentData,
        OperationError<CreateVoiceAgentError>,
        MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateVoiceAgentSchema,
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateVoiceAgentData,
          OperationError<CreateVoiceAgentError>,
          MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateVoiceAgentSchema,
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.createVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.createVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateVoiceAgentBody,
              CreateVoiceAgentData,
              CreateVoiceAgentParameters,
              OperationError<CreateVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateVoiceAgentSchema,
              CreateVoiceAgentBody,
              CreateVoiceAgentData,
              CreateVoiceAgentParameters,
              OperationError<CreateVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            CreateVoiceAgentData,
            CreateVoiceAgentError,
            MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateVoiceAgentBody,
              CreateVoiceAgentData,
              CreateVoiceAgentParameters,
              OperationError<CreateVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateVoiceAgentSchema,
              CreateVoiceAgentBody,
              CreateVoiceAgentData,
              CreateVoiceAgentParameters,
              OperationError<CreateVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateVoiceAgentData,
          CreateVoiceAgentError,
          MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: CreateVoiceAgentSchema;
    types: {
      parameters: CreateVoiceAgentParameters;
      data: CreateVoiceAgentData;
      error: CreateVoiceAgentError;
      body: CreateVoiceAgentBody;
    };
  };
  /** @summary Update */
  updateVoiceAgent: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateVoiceAgentBody, UpdateVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<UpdateVoiceAgentBody, UpdateVoiceAgentParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateVoiceAgentData, UpdateVoiceAgentError>>
    ): Promise<RequestFnResponse<UpdateVoiceAgentData, UpdateVoiceAgentError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<UpdateVoiceAgentSchema, UpdateVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateVoiceAgentSchema,
        UpdateVoiceAgentData,
        UpdateVoiceAgentParameters,
        TVariables,
        OperationError<UpdateVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<UpdateVoiceAgentData, OperationError<UpdateVoiceAgentError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateVoiceAgentSchema,
        UpdateVoiceAgentData,
        UpdateVoiceAgentParameters,
        TVariables,
        OperationError<UpdateVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<UpdateVoiceAgentData, OperationError<UpdateVoiceAgentError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateVoiceAgentTotal = qraft.agentService.updateVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateVoiceAgentTotal = qraft.agentService.updateVoiceAgent.useIsMutating({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateVoiceAgentSchema,
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateVoiceAgentPendingMutationVariables = qraft.agentService.updateVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateVoiceAgentMutationData = qraft.agentService.updateVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 id: id
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateVoiceAgentData,
        OperationError<UpdateVoiceAgentError>,
        MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateVoiceAgentSchema,
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateVoiceAgentData,
          OperationError<UpdateVoiceAgentError>,
          MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateVoiceAgentSchema,
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.updateVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.updateVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateVoiceAgentBody,
              UpdateVoiceAgentData,
              UpdateVoiceAgentParameters,
              OperationError<UpdateVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateVoiceAgentSchema,
              UpdateVoiceAgentBody,
              UpdateVoiceAgentData,
              UpdateVoiceAgentParameters,
              OperationError<UpdateVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            UpdateVoiceAgentData,
            UpdateVoiceAgentError,
            MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateVoiceAgentBody,
              UpdateVoiceAgentData,
              UpdateVoiceAgentParameters,
              OperationError<UpdateVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateVoiceAgentSchema,
              UpdateVoiceAgentBody,
              UpdateVoiceAgentData,
              UpdateVoiceAgentParameters,
              OperationError<UpdateVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateVoiceAgentData,
          UpdateVoiceAgentError,
          MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: UpdateVoiceAgentSchema;
    types: {
      parameters: UpdateVoiceAgentParameters;
      data: UpdateVoiceAgentData;
      error: UpdateVoiceAgentError;
      body: UpdateVoiceAgentBody;
    };
  };
  /** @summary Build */
  buildVoiceAgent: {
    /** @summary Build */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<BuildVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: BuildVoiceAgentSchema,
        options: {
          parameters: BuildVoiceAgentParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<BuildVoiceAgentData, BuildVoiceAgentError>>
    ): Promise<RequestFnResponse<BuildVoiceAgentData, BuildVoiceAgentError>>;
    /** @summary Build */
    getQueryKey(
      parameters: DeepReadonly<BuildVoiceAgentParameters>
    ): ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.buildVoiceAgent.useQuery({
     *     path: {
     *         id: id
     *     }
     * })
     * ```
     */
    useQuery<TData = BuildVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          BuildVoiceAgentData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.buildVoiceAgent.useQuery({
     *     path: {
     *         id: id
     *     }
     * })
     * ```
     */
    useQuery<TData = BuildVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          BuildVoiceAgentData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /** @summary Build */
    getInfiniteQueryKey(
      parameters: DeepReadonly<BuildVoiceAgentParameters>
    ): ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.buildVoiceAgent.useInfiniteQuery({
     *     path: {
     *         id: id
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends BuildVoiceAgentParameters,
      TQueryFnData = BuildVoiceAgentData,
      TData = OperationInfiniteData<TQueryFnData, BuildVoiceAgentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.buildVoiceAgent.useInfiniteQuery({
     *     path: {
     *         id: id
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends BuildVoiceAgentParameters,
      TQueryFnData = BuildVoiceAgentData,
      TData = OperationInfiniteData<TQueryFnData, BuildVoiceAgentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<BuildVoiceAgentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const buildVoiceAgentTotal = qraft.agentService.buildVoiceAgent.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const buildVoiceAgentByParametersTotal = qraft.agentService.buildVoiceAgent.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const buildVoiceAgentResults = qraft.agentService.buildVoiceAgent.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * buildVoiceAgentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const buildVoiceAgentCombinedResults = qraft.agentService.buildVoiceAgent.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * buildVoiceAgentCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          BuildVoiceAgentSchema,
          BuildVoiceAgentParameters,
          BuildVoiceAgentData,
          BuildVoiceAgentError
        >
      >,
      TCombinedResult = Array<UseQueryResult<BuildVoiceAgentData, BuildVoiceAgentError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<BuildVoiceAgentData, BuildVoiceAgentError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.agentService.buildVoiceAgent.useSuspenseQuery({
     *     path: {
     *         id: id
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = BuildVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          BuildVoiceAgentData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.buildVoiceAgent.useSuspenseInfiniteQuery({
     *     path: {
     *         id: id
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends BuildVoiceAgentParameters, TData = BuildVoiceAgentData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          BuildVoiceAgentData,
          BuildVoiceAgentError,
          OperationInfiniteData<TData, BuildVoiceAgentParameters>,
          ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<BuildVoiceAgentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, BuildVoiceAgentParameters>,
      OperationError<BuildVoiceAgentError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const buildVoiceAgentData = qraft.agentService.buildVoiceAgent.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * buildVoiceAgentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const buildVoiceAgentCombinedData = qraft.agentService.buildVoiceAgent.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * buildVoiceAgentCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          BuildVoiceAgentSchema,
          BuildVoiceAgentParameters,
          BuildVoiceAgentData,
          BuildVoiceAgentError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<BuildVoiceAgentData, BuildVoiceAgentError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<BuildVoiceAgentData, BuildVoiceAgentError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Build */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        BuildVoiceAgentError
      >
    ): Promise<BuildVoiceAgentData>;
    /** @summary Build */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        BuildVoiceAgentError
      >
    ): Promise<void>;
    /** @summary Build */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        BuildVoiceAgentError
      >
    ): Promise<BuildVoiceAgentData>;
    /** @summary Build */
    fetchInfiniteQuery<TPageParam extends BuildVoiceAgentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        BuildVoiceAgentError
      >
    ): Promise<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>>;
    /** @summary Build */
    prefetchInfiniteQuery<TPageParam extends BuildVoiceAgentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        BuildVoiceAgentError
      >
    ): Promise<void>;
    /** @summary Build */
    ensureInfiniteQueryData<TPageParam extends BuildVoiceAgentParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        BuildVoiceAgentError
      >
    ): Promise<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>>;
    /** @summary Build */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>
    ): BuildVoiceAgentData | undefined;
    /** @summary Build */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>
    ): OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters> | undefined;
    /** @summary Build */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
            data: NoInfer<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
            data: BuildVoiceAgentData | undefined,
          ]
        >;
    /** @summary Build */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>
    ): QueryState<BuildVoiceAgentData, BuildVoiceAgentError> | undefined;
    /** @summary Build */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<BuildVoiceAgentParameters>
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
    ):
      | QueryState<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>, BuildVoiceAgentError>
      | undefined;
    /** @summary Build */
    setQueryData(
      parameters:
        | DeepReadonly<BuildVoiceAgentParameters>
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
      updater: Updater<
        NoInfer<BuildVoiceAgentData> | undefined,
        NoInfer<DeepReadonly<BuildVoiceAgentData>> | undefined
      >,
      options?: SetDataOptions
    ): BuildVoiceAgentData | undefined;
    /** @summary Build */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<BuildVoiceAgentParameters>
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters> | undefined;
    /** @summary Build */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >,
      updater: Updater<NoInfer<BuildVoiceAgentData> | undefined, NoInfer<BuildVoiceAgentData> | undefined>,
      options?: SetDataOptions
    ): Array<BuildVoiceAgentData | undefined>;
    /** @summary Build */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        TInfinite,
        BuildVoiceAgentParameters,
        BuildVoiceAgentError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Build */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Build */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Build */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
    ): void;
    /** @summary Build */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Build */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
    ): number;
    schema: BuildVoiceAgentSchema;
    types: {
      parameters: BuildVoiceAgentParameters;
      data: BuildVoiceAgentData;
      error: BuildVoiceAgentError;
    };
  };
  /** @summary Publish */
  publishVoiceAgent: {
    /** @summary Publish */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<PublishVoiceAgentBody, PublishVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: PublishVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<PublishVoiceAgentBody, PublishVoiceAgentParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<PublishVoiceAgentData, PublishVoiceAgentError>>
    ): Promise<RequestFnResponse<PublishVoiceAgentData, PublishVoiceAgentError>>;
    /** @summary Publish */
    getMutationKey(
      parameters: DeepReadonly<PublishVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<PublishVoiceAgentSchema, PublishVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.publishVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.publishVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends PublishVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<PublishVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        PublishVoiceAgentSchema,
        PublishVoiceAgentData,
        PublishVoiceAgentParameters,
        TVariables,
        OperationError<PublishVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<PublishVoiceAgentData, OperationError<PublishVoiceAgentError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.publishVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.publishVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        PublishVoiceAgentSchema,
        PublishVoiceAgentData,
        PublishVoiceAgentParameters,
        TVariables,
        OperationError<PublishVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<PublishVoiceAgentData, OperationError<PublishVoiceAgentError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const publishVoiceAgentTotal = qraft.agentService.publishVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const publishVoiceAgentTotal = qraft.agentService.publishVoiceAgent.useIsMutating({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PublishVoiceAgentSchema,
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const publishVoiceAgentPendingMutationVariables = qraft.agentService.publishVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const publishVoiceAgentMutationData = qraft.agentService.publishVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 id: id
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        PublishVoiceAgentData,
        OperationError<PublishVoiceAgentError>,
        MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PublishVoiceAgentSchema,
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          PublishVoiceAgentData,
          OperationError<PublishVoiceAgentError>,
          MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Publish */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PublishVoiceAgentSchema,
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.publishVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.publishVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              PublishVoiceAgentBody,
              PublishVoiceAgentData,
              PublishVoiceAgentParameters,
              OperationError<PublishVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PublishVoiceAgentSchema,
              PublishVoiceAgentBody,
              PublishVoiceAgentData,
              PublishVoiceAgentParameters,
              OperationError<PublishVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            PublishVoiceAgentData,
            PublishVoiceAgentError,
            MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              PublishVoiceAgentBody,
              PublishVoiceAgentData,
              PublishVoiceAgentParameters,
              OperationError<PublishVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PublishVoiceAgentSchema,
              PublishVoiceAgentBody,
              PublishVoiceAgentData,
              PublishVoiceAgentParameters,
              OperationError<PublishVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          PublishVoiceAgentData,
          PublishVoiceAgentError,
          MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: PublishVoiceAgentSchema;
    types: {
      parameters: PublishVoiceAgentParameters;
      data: PublishVoiceAgentData;
      error: PublishVoiceAgentError;
      body: PublishVoiceAgentBody;
    };
  };
  /** @summary Sync With Config */
  syncVoiceAgent: {
    /** @summary Sync With Config */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<SyncVoiceAgentBody, SyncVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: SyncVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<SyncVoiceAgentBody, SyncVoiceAgentParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<SyncVoiceAgentData, SyncVoiceAgentError>>
    ): Promise<RequestFnResponse<SyncVoiceAgentData, SyncVoiceAgentError>>;
    /** @summary Sync With Config */
    getMutationKey(
      parameters: DeepReadonly<SyncVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<SyncVoiceAgentSchema, SyncVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.syncVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.syncVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SyncVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<SyncVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        SyncVoiceAgentSchema,
        SyncVoiceAgentData,
        SyncVoiceAgentParameters,
        TVariables,
        OperationError<SyncVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<SyncVoiceAgentData, OperationError<SyncVoiceAgentError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.syncVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.syncVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SyncVoiceAgentSchema,
        SyncVoiceAgentData,
        SyncVoiceAgentParameters,
        TVariables,
        OperationError<SyncVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<SyncVoiceAgentData, OperationError<SyncVoiceAgentError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const syncVoiceAgentTotal = qraft.agentService.syncVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const syncVoiceAgentTotal = qraft.agentService.syncVoiceAgent.useIsMutating({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SyncVoiceAgentSchema,
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const syncVoiceAgentPendingMutationVariables = qraft.agentService.syncVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const syncVoiceAgentMutationData = qraft.agentService.syncVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 id: id
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SyncVoiceAgentData,
        OperationError<SyncVoiceAgentError>,
        MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SyncVoiceAgentSchema,
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SyncVoiceAgentData,
          OperationError<SyncVoiceAgentError>,
          MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Sync With Config */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SyncVoiceAgentSchema,
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.syncVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.syncVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SyncVoiceAgentBody,
              SyncVoiceAgentData,
              SyncVoiceAgentParameters,
              OperationError<SyncVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SyncVoiceAgentSchema,
              SyncVoiceAgentBody,
              SyncVoiceAgentData,
              SyncVoiceAgentParameters,
              OperationError<SyncVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            SyncVoiceAgentData,
            SyncVoiceAgentError,
            MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SyncVoiceAgentBody,
              SyncVoiceAgentData,
              SyncVoiceAgentParameters,
              OperationError<SyncVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SyncVoiceAgentSchema,
              SyncVoiceAgentBody,
              SyncVoiceAgentData,
              SyncVoiceAgentParameters,
              OperationError<SyncVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          SyncVoiceAgentData,
          SyncVoiceAgentError,
          MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: SyncVoiceAgentSchema;
    types: {
      parameters: SyncVoiceAgentParameters;
      data: SyncVoiceAgentData;
      error: SyncVoiceAgentError;
      body: SyncVoiceAgentBody;
    };
  };
  /** @summary Start Call */
  startTestCall: {
    /** @summary Start Call */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<StartTestCallBody, StartTestCallParameters, TMeta, TSignal>,
      client?: (
        schema: StartTestCallSchema,
        options: ServiceOperationMutationFnOptions<StartTestCallBody, StartTestCallParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<StartTestCallData, StartTestCallError>>
    ): Promise<RequestFnResponse<StartTestCallData, StartTestCallError>>;
    /** @summary Start Call */
    getMutationKey(
      parameters: DeepReadonly<StartTestCallParameters> | void
    ): ServiceOperationMutationKey<StartTestCallSchema, StartTestCallParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.startTestCall.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.startTestCall.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends StartTestCallBody, TContext = unknown>(
      parameters: DeepReadonly<StartTestCallParameters>,
      options?: ServiceOperationUseMutationOptions<
        StartTestCallSchema,
        StartTestCallData,
        StartTestCallParameters,
        TVariables,
        OperationError<StartTestCallError>,
        TContext
      >
    ): UseMutationResult<StartTestCallData, OperationError<StartTestCallError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.startTestCall.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.startTestCall.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<StartTestCallBody, StartTestCallParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        StartTestCallSchema,
        StartTestCallData,
        StartTestCallParameters,
        TVariables,
        OperationError<StartTestCallError>,
        TContext
      >
    ): UseMutationResult<StartTestCallData, OperationError<StartTestCallError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const startTestCallTotal = qraft.agentService.startTestCall.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const startTestCallTotal = qraft.agentService.startTestCall.useIsMutating({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            StartTestCallSchema,
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const startTestCallPendingMutationVariables = qraft.agentService.startTestCall.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const startTestCallMutationData = qraft.agentService.startTestCall.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 id: id
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        StartTestCallData,
        OperationError<StartTestCallError>,
        MutationVariables<StartTestCallBody, StartTestCallParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            StartTestCallSchema,
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          StartTestCallData,
          OperationError<StartTestCallError>,
          MutationVariables<StartTestCallBody, StartTestCallParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Start Call */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            StartTestCallSchema,
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.startTestCall.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.startTestCall.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              StartTestCallBody,
              StartTestCallData,
              StartTestCallParameters,
              OperationError<StartTestCallError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              StartTestCallSchema,
              StartTestCallBody,
              StartTestCallData,
              StartTestCallParameters,
              OperationError<StartTestCallError>,
              TContext
            >
      ):
        | Mutation<
            StartTestCallData,
            StartTestCallError,
            MutationVariables<StartTestCallBody, StartTestCallParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              StartTestCallBody,
              StartTestCallData,
              StartTestCallParameters,
              OperationError<StartTestCallError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              StartTestCallSchema,
              StartTestCallBody,
              StartTestCallData,
              StartTestCallParameters,
              OperationError<StartTestCallError>,
              TContext
            >
      ): Array<
        Mutation<
          StartTestCallData,
          StartTestCallError,
          MutationVariables<StartTestCallBody, StartTestCallParameters>,
          TContext
        >
      >;
    };
    schema: StartTestCallSchema;
    types: {
      parameters: StartTestCallParameters;
      data: StartTestCallData;
      error: StartTestCallError;
      body: StartTestCallBody;
    };
  };
  /** @summary List Voices */
  listVoices: {
    /** @summary List Voices */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListVoicesSchema, ListVoicesParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListVoicesParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListVoicesSchema,
        options: {
          parameters: ListVoicesParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListVoicesData, ListVoicesError>>
    ): Promise<RequestFnResponse<ListVoicesData, ListVoicesError>>;
    /** @summary List Voices */
    getQueryKey(
      parameters: DeepReadonly<ListVoicesParameters> | void
    ): ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.listVoices.useQuery()
     * ```
     */
    useQuery<TData = ListVoicesData>(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListVoicesData,
          ListVoicesError,
          TData,
          ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListVoicesError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.listVoices.useQuery()
     * ```
     */
    useQuery<TData = ListVoicesData>(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListVoicesData,
          ListVoicesError,
          TData,
          ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListVoicesError>>;
    /** @summary List Voices */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListVoicesParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listVoices.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListVoicesParameters,
      TQueryFnData = ListVoicesData,
      TData = OperationInfiniteData<TQueryFnData, ListVoicesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListVoicesError,
          TData,
          ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListVoicesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listVoices.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListVoicesParameters,
      TQueryFnData = ListVoicesData,
      TData = OperationInfiniteData<TQueryFnData, ListVoicesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListVoicesError,
          TData,
          ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListVoicesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListVoicesError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listVoicesTotal = qraft.agentService.listVoices.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listVoicesResults = qraft.agentService.listVoices.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoicesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listVoicesCombinedResults = qraft.agentService.listVoices.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoicesCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<ListVoicesSchema, ListVoicesParameters, ListVoicesData, ListVoicesError>
      >,
      TCombinedResult = Array<UseQueryResult<ListVoicesData, ListVoicesError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListVoicesData, ListVoicesError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentService.listVoices.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListVoicesData>(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListVoicesData,
          ListVoicesError,
          TData,
          ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListVoicesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listVoices.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListVoicesParameters, TData = ListVoicesData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListVoicesData,
          ListVoicesError,
          OperationInfiniteData<TData, ListVoicesParameters>,
          ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListVoicesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListVoicesParameters>,
      OperationError<ListVoicesError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listVoicesData = qraft.agentService.listVoices.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoicesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listVoicesCombinedData = qraft.agentService.listVoices.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoicesCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<ListVoicesSchema, ListVoicesParameters, ListVoicesData, ListVoicesError>
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListVoicesData, ListVoicesError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListVoicesData, ListVoicesError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Voices */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        ListVoicesError
      > | void
    ): Promise<ListVoicesData>;
    /** @summary List Voices */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        ListVoicesError
      > | void
    ): Promise<void>;
    /** @summary List Voices */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        ListVoicesError
      > | void
    ): Promise<ListVoicesData>;
    /** @summary List Voices */
    fetchInfiniteQuery<TPageParam extends ListVoicesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        DeepReadonly<TPageParam>,
        ListVoicesError
      > | void
    ): Promise<OperationInfiniteData<ListVoicesData, ListVoicesParameters>>;
    /** @summary List Voices */
    prefetchInfiniteQuery<TPageParam extends ListVoicesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        DeepReadonly<TPageParam>,
        ListVoicesError
      > | void
    ): Promise<void>;
    /** @summary List Voices */
    ensureInfiniteQueryData<TPageParam extends ListVoicesParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        DeepReadonly<TPageParam>,
        ListVoicesError
      > | void
    ): Promise<OperationInfiniteData<ListVoicesData, ListVoicesParameters>>;
    /** @summary List Voices */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void)
    ): ListVoicesData | undefined;
    /** @summary List Voices */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void)
    ): OperationInfiniteData<ListVoicesData, ListVoicesParameters> | undefined;
    /** @summary List Voices */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
            data: NoInfer<OperationInfiniteData<ListVoicesData, ListVoicesParameters>> | undefined,
          ]
        >
      : Array<
          [queryKey: ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>, data: ListVoicesData | undefined]
        >;
    /** @summary List Voices */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void)
    ): QueryState<ListVoicesData, ListVoicesError> | undefined;
    /** @summary List Voices */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListVoicesParameters>
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | void
    ): QueryState<OperationInfiniteData<ListVoicesData, ListVoicesParameters>, ListVoicesError> | undefined;
    /** @summary List Voices */
    setQueryData(
      parameters:
        | (DeepReadonly<ListVoicesParameters> | undefined)
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>,
      updater: Updater<NoInfer<ListVoicesData> | undefined, NoInfer<DeepReadonly<ListVoicesData>> | undefined>,
      options?: SetDataOptions
    ): ListVoicesData | undefined;
    /** @summary List Voices */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListVoicesParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListVoicesData, ListVoicesParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListVoicesData, ListVoicesParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListVoicesData, ListVoicesParameters> | undefined;
    /** @summary List Voices */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>,
      updater: Updater<NoInfer<ListVoicesData> | undefined, NoInfer<ListVoicesData> | undefined>,
      options?: SetDataOptions
    ): Array<ListVoicesData | undefined>;
    /** @summary List Voices */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListVoicesSchema,
        ListVoicesData,
        TInfinite,
        ListVoicesParameters,
        ListVoicesError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Voices */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Voices */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Voices */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
    ): void;
    /** @summary List Voices */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Voices */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
    ): number;
    schema: ListVoicesSchema;
    types: {
      parameters: ListVoicesParameters;
      data: ListVoicesData;
      error: ListVoicesError;
    };
  };
  /** @summary Run Sync */
  runVoiceAgentSync: {
    /** @summary Run Sync */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters, TMeta, TSignal>,
      client?: (
        schema: RunVoiceAgentSyncSchema,
        options: ServiceOperationMutationFnOptions<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<RunVoiceAgentSyncData, RunVoiceAgentSyncError>>
    ): Promise<RequestFnResponse<RunVoiceAgentSyncData, RunVoiceAgentSyncError>>;
    /** @summary Run Sync */
    getMutationKey(
      parameters: DeepReadonly<RunVoiceAgentSyncParameters> | void
    ): ServiceOperationMutationKey<RunVoiceAgentSyncSchema, RunVoiceAgentSyncParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.runVoiceAgentSync.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.runVoiceAgentSync.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends RunVoiceAgentSyncBody, TContext = unknown>(
      parameters: DeepReadonly<RunVoiceAgentSyncParameters>,
      options?: ServiceOperationUseMutationOptions<
        RunVoiceAgentSyncSchema,
        RunVoiceAgentSyncData,
        RunVoiceAgentSyncParameters,
        TVariables,
        OperationError<RunVoiceAgentSyncError>,
        TContext
      >
    ): UseMutationResult<RunVoiceAgentSyncData, OperationError<RunVoiceAgentSyncError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.runVoiceAgentSync.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.runVoiceAgentSync.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RunVoiceAgentSyncSchema,
        RunVoiceAgentSyncData,
        RunVoiceAgentSyncParameters,
        TVariables,
        OperationError<RunVoiceAgentSyncError>,
        TContext
      >
    ): UseMutationResult<RunVoiceAgentSyncData, OperationError<RunVoiceAgentSyncError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const runVoiceAgentSyncTotal = qraft.agentService.runVoiceAgentSync.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const runVoiceAgentSyncTotal = qraft.agentService.runVoiceAgentSync.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RunVoiceAgentSyncSchema,
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const runVoiceAgentSyncPendingMutationVariables = qraft.agentService.runVoiceAgentSync.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const runVoiceAgentSyncMutationData = qraft.agentService.runVoiceAgentSync.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RunVoiceAgentSyncData,
        OperationError<RunVoiceAgentSyncError>,
        MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RunVoiceAgentSyncSchema,
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RunVoiceAgentSyncData,
          OperationError<RunVoiceAgentSyncError>,
          MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Run Sync */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RunVoiceAgentSyncSchema,
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.runVoiceAgentSync.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.runVoiceAgentSync.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RunVoiceAgentSyncBody,
              RunVoiceAgentSyncData,
              RunVoiceAgentSyncParameters,
              OperationError<RunVoiceAgentSyncError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RunVoiceAgentSyncSchema,
              RunVoiceAgentSyncBody,
              RunVoiceAgentSyncData,
              RunVoiceAgentSyncParameters,
              OperationError<RunVoiceAgentSyncError>,
              TContext
            >
      ):
        | Mutation<
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncError,
            MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RunVoiceAgentSyncBody,
              RunVoiceAgentSyncData,
              RunVoiceAgentSyncParameters,
              OperationError<RunVoiceAgentSyncError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RunVoiceAgentSyncSchema,
              RunVoiceAgentSyncBody,
              RunVoiceAgentSyncData,
              RunVoiceAgentSyncParameters,
              OperationError<RunVoiceAgentSyncError>,
              TContext
            >
      ): Array<
        Mutation<
          RunVoiceAgentSyncData,
          RunVoiceAgentSyncError,
          MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
          TContext
        >
      >;
    };
    schema: RunVoiceAgentSyncSchema;
    types: {
      parameters: RunVoiceAgentSyncParameters;
      data: RunVoiceAgentSyncData;
      error: RunVoiceAgentSyncError;
      body: RunVoiceAgentSyncBody;
    };
  };
  /** @summary List */
  listAgentConfigs: {
    /** @summary List */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListAgentConfigsParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListAgentConfigsSchema,
        options: {
          parameters: ListAgentConfigsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListAgentConfigsData, ListAgentConfigsError>>
    ): Promise<RequestFnResponse<ListAgentConfigsData, ListAgentConfigsError>>;
    /** @summary List */
    getQueryKey(
      parameters: DeepReadonly<ListAgentConfigsParameters> | void
    ): ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.listAgentConfigs.useQuery()
     * ```
     */
    useQuery<TData = ListAgentConfigsData>(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListAgentConfigsData,
          ListAgentConfigsError,
          TData,
          ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.listAgentConfigs.useQuery()
     * ```
     */
    useQuery<TData = ListAgentConfigsData>(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListAgentConfigsData,
          ListAgentConfigsError,
          TData,
          ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /** @summary List */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListAgentConfigsParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listAgentConfigs.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAgentConfigsParameters,
      TQueryFnData = ListAgentConfigsData,
      TData = OperationInfiniteData<TQueryFnData, ListAgentConfigsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAgentConfigsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listAgentConfigs.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAgentConfigsParameters,
      TQueryFnData = ListAgentConfigsData,
      TData = OperationInfiniteData<TQueryFnData, ListAgentConfigsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAgentConfigsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAgentConfigsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listAgentConfigsTotal = qraft.agentService.listAgentConfigs.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listAgentConfigsResults = qraft.agentService.listAgentConfigs.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAgentConfigsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listAgentConfigsCombinedResults = qraft.agentService.listAgentConfigs.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAgentConfigsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListAgentConfigsSchema,
          ListAgentConfigsParameters,
          ListAgentConfigsData,
          ListAgentConfigsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListAgentConfigsData, ListAgentConfigsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListAgentConfigsData, ListAgentConfigsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentService.listAgentConfigs.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListAgentConfigsData>(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListAgentConfigsData,
          ListAgentConfigsError,
          TData,
          ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListAgentConfigsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listAgentConfigs.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListAgentConfigsParameters, TData = ListAgentConfigsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListAgentConfigsData,
          ListAgentConfigsError,
          OperationInfiniteData<TData, ListAgentConfigsParameters>,
          ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAgentConfigsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListAgentConfigsParameters>,
      OperationError<ListAgentConfigsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listAgentConfigsData = qraft.agentService.listAgentConfigs.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAgentConfigsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listAgentConfigsCombinedData = qraft.agentService.listAgentConfigs.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAgentConfigsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListAgentConfigsSchema,
          ListAgentConfigsParameters,
          ListAgentConfigsData,
          ListAgentConfigsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListAgentConfigsData, ListAgentConfigsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListAgentConfigsData, ListAgentConfigsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        ListAgentConfigsError
      > | void
    ): Promise<ListAgentConfigsData>;
    /** @summary List */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        ListAgentConfigsError
      > | void
    ): Promise<void>;
    /** @summary List */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        ListAgentConfigsError
      > | void
    ): Promise<ListAgentConfigsData>;
    /** @summary List */
    fetchInfiniteQuery<TPageParam extends ListAgentConfigsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        DeepReadonly<TPageParam>,
        ListAgentConfigsError
      > | void
    ): Promise<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>>;
    /** @summary List */
    prefetchInfiniteQuery<TPageParam extends ListAgentConfigsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        DeepReadonly<TPageParam>,
        ListAgentConfigsError
      > | void
    ): Promise<void>;
    /** @summary List */
    ensureInfiniteQueryData<TPageParam extends ListAgentConfigsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        ListAgentConfigsParameters,
        DeepReadonly<TPageParam>,
        ListAgentConfigsError
      > | void
    ): Promise<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>>;
    /** @summary List */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void)
    ): ListAgentConfigsData | undefined;
    /** @summary List */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void)
    ): OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters> | undefined;
    /** @summary List */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
            data: NoInfer<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
            data: ListAgentConfigsData | undefined,
          ]
        >;
    /** @summary List */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | (DeepReadonly<ListAgentConfigsParameters> | void)
    ): QueryState<ListAgentConfigsData, ListAgentConfigsError> | undefined;
    /** @summary List */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListAgentConfigsParameters>
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>, ListAgentConfigsError>
      | undefined;
    /** @summary List */
    setQueryData(
      parameters:
        | (DeepReadonly<ListAgentConfigsParameters> | undefined)
        | ServiceOperationQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
      updater: Updater<
        NoInfer<ListAgentConfigsData> | undefined,
        NoInfer<DeepReadonly<ListAgentConfigsData>> | undefined
      >,
      options?: SetDataOptions
    ): ListAgentConfigsData | undefined;
    /** @summary List */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListAgentConfigsParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListAgentConfigsSchema, ListAgentConfigsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListAgentConfigsData, ListAgentConfigsParameters> | undefined;
    /** @summary List */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >,
      updater: Updater<NoInfer<ListAgentConfigsData> | undefined, NoInfer<ListAgentConfigsData> | undefined>,
      options?: SetDataOptions
    ): Array<ListAgentConfigsData | undefined>;
    /** @summary List */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListAgentConfigsSchema,
        ListAgentConfigsData,
        TInfinite,
        ListAgentConfigsParameters,
        ListAgentConfigsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
    ): void;
    /** @summary List */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
        | QueryFiltersByQueryKey<
            ListAgentConfigsSchema,
            ListAgentConfigsData,
            TInfinite,
            ListAgentConfigsParameters,
            ListAgentConfigsError
          >
    ): number;
    schema: ListAgentConfigsSchema;
    types: {
      parameters: ListAgentConfigsParameters;
      data: ListAgentConfigsData;
      error: ListAgentConfigsError;
    };
  };
  /** @summary Create */
  createAgentConfig: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateAgentConfigBody, CreateAgentConfigParameters, TMeta, TSignal>,
      client?: (
        schema: CreateAgentConfigSchema,
        options: ServiceOperationMutationFnOptions<CreateAgentConfigBody, CreateAgentConfigParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateAgentConfigData, CreateAgentConfigError>>
    ): Promise<RequestFnResponse<CreateAgentConfigData, CreateAgentConfigError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateAgentConfigParameters> | void
    ): ServiceOperationMutationKey<CreateAgentConfigSchema, CreateAgentConfigParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createAgentConfig.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createAgentConfig.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateAgentConfigBody, TContext = unknown>(
      parameters: DeepReadonly<CreateAgentConfigParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateAgentConfigSchema,
        CreateAgentConfigData,
        CreateAgentConfigParameters,
        TVariables,
        OperationError<CreateAgentConfigError>,
        TContext
      >
    ): UseMutationResult<CreateAgentConfigData, OperationError<CreateAgentConfigError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createAgentConfig.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createAgentConfig.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateAgentConfigSchema,
        CreateAgentConfigData,
        CreateAgentConfigParameters,
        TVariables,
        OperationError<CreateAgentConfigError>,
        TContext
      >
    ): UseMutationResult<CreateAgentConfigData, OperationError<CreateAgentConfigError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createAgentConfigTotal = qraft.agentService.createAgentConfig.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createAgentConfigTotal = qraft.agentService.createAgentConfig.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateAgentConfigSchema,
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createAgentConfigPendingMutationVariables = qraft.agentService.createAgentConfig.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createAgentConfigMutationData = qraft.agentService.createAgentConfig.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateAgentConfigData,
        OperationError<CreateAgentConfigError>,
        MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateAgentConfigSchema,
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateAgentConfigData,
          OperationError<CreateAgentConfigError>,
          MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateAgentConfigSchema,
            CreateAgentConfigBody,
            CreateAgentConfigData,
            CreateAgentConfigParameters,
            OperationError<CreateAgentConfigError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.createAgentConfig.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.createAgentConfig.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateAgentConfigBody,
              CreateAgentConfigData,
              CreateAgentConfigParameters,
              OperationError<CreateAgentConfigError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateAgentConfigSchema,
              CreateAgentConfigBody,
              CreateAgentConfigData,
              CreateAgentConfigParameters,
              OperationError<CreateAgentConfigError>,
              TContext
            >
      ):
        | Mutation<
            CreateAgentConfigData,
            CreateAgentConfigError,
            MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateAgentConfigBody,
              CreateAgentConfigData,
              CreateAgentConfigParameters,
              OperationError<CreateAgentConfigError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateAgentConfigSchema,
              CreateAgentConfigBody,
              CreateAgentConfigData,
              CreateAgentConfigParameters,
              OperationError<CreateAgentConfigError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateAgentConfigData,
          CreateAgentConfigError,
          MutationVariables<CreateAgentConfigBody, CreateAgentConfigParameters>,
          TContext
        >
      >;
    };
    schema: CreateAgentConfigSchema;
    types: {
      parameters: CreateAgentConfigParameters;
      data: CreateAgentConfigData;
      error: CreateAgentConfigError;
      body: CreateAgentConfigBody;
    };
  };
  /** @summary Get */
  getAgentConfig: {
    /** @summary Get */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAgentConfigSchema, GetAgentConfigParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetAgentConfigParameters, TMeta, TSignal>,
      client?: (
        schema: GetAgentConfigSchema,
        options: {
          parameters: GetAgentConfigParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAgentConfigData, GetAgentConfigError>>
    ): Promise<RequestFnResponse<GetAgentConfigData, GetAgentConfigError>>;
    /** @summary Get */
    getQueryKey(
      parameters: DeepReadonly<GetAgentConfigParameters>
    ): ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.getAgentConfig.useQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAgentConfigData>(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAgentConfigData,
          GetAgentConfigError,
          TData,
          ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAgentConfigError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.getAgentConfig.useQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAgentConfigData>(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetAgentConfigData,
          GetAgentConfigError,
          TData,
          ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAgentConfigError>>;
    /** @summary Get */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAgentConfigParameters>
    ): ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.getAgentConfig.useInfiniteQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAgentConfigParameters,
      TQueryFnData = GetAgentConfigData,
      TData = OperationInfiniteData<TQueryFnData, GetAgentConfigParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAgentConfigError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAgentConfigError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.getAgentConfig.useInfiniteQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAgentConfigParameters,
      TQueryFnData = GetAgentConfigData,
      TData = OperationInfiniteData<TQueryFnData, GetAgentConfigParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAgentConfigError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAgentConfigData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAgentConfigError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAgentConfigTotal = qraft.agentService.getAgentConfig.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAgentConfigByParametersTotal = qraft.agentService.getAgentConfig.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             agent_config_id: agentConfigId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAgentConfigResults = qraft.agentService.getAgentConfig.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId1
     *             }
     *         },
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId2
     *             }
     *         }
     *     ]
     * });
     * getAgentConfigResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAgentConfigCombinedResults = qraft.agentService.getAgentConfig.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId1
     *             }
     *         },
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId2
     *             }
     *         }
     *     ]
     * });
     * getAgentConfigCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAgentConfigSchema,
          GetAgentConfigParameters,
          GetAgentConfigData,
          GetAgentConfigError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAgentConfigData, GetAgentConfigError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAgentConfigData, GetAgentConfigError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.agentService.getAgentConfig.useSuspenseQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAgentConfigData>(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAgentConfigData,
          GetAgentConfigError,
          TData,
          ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAgentConfigError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.getAgentConfig.useSuspenseInfiniteQuery({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAgentConfigParameters, TData = GetAgentConfigData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAgentConfigData,
          GetAgentConfigError,
          OperationInfiniteData<TData, GetAgentConfigParameters>,
          ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAgentConfigData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAgentConfigParameters>,
      OperationError<GetAgentConfigError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAgentConfigData = qraft.agentService.getAgentConfig.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId1
     *             }
     *         },
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId2
     *             }
     *         }
     *     ]
     * });
     * getAgentConfigResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAgentConfigCombinedData = qraft.agentService.getAgentConfig.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId1
     *             }
     *         },
     *         {
     *             path: {
     *                 agent_config_id: agentConfigId2
     *             }
     *         }
     *     ]
     * });
     * getAgentConfigCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAgentConfigSchema,
          GetAgentConfigParameters,
          GetAgentConfigData,
          GetAgentConfigError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAgentConfigData, GetAgentConfigError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAgentConfigData, GetAgentConfigError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        GetAgentConfigError
      >
    ): Promise<GetAgentConfigData>;
    /** @summary Get */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        GetAgentConfigError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        GetAgentConfigError
      >
    ): Promise<GetAgentConfigData>;
    /** @summary Get */
    fetchInfiniteQuery<TPageParam extends GetAgentConfigParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        DeepReadonly<TPageParam>,
        GetAgentConfigError
      >
    ): Promise<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>>;
    /** @summary Get */
    prefetchInfiniteQuery<TPageParam extends GetAgentConfigParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        DeepReadonly<TPageParam>,
        GetAgentConfigError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureInfiniteQueryData<TPageParam extends GetAgentConfigParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAgentConfigSchema,
        GetAgentConfigData,
        GetAgentConfigParameters,
        DeepReadonly<TPageParam>,
        GetAgentConfigError
      >
    ): Promise<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>>;
    /** @summary Get */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>
    ): GetAgentConfigData | undefined;
    /** @summary Get */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>
    ): OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters> | undefined;
    /** @summary Get */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
            data: NoInfer<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
            data: GetAgentConfigData | undefined,
          ]
        >;
    /** @summary Get */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
        | DeepReadonly<GetAgentConfigParameters>
    ): QueryState<GetAgentConfigData, GetAgentConfigError> | undefined;
    /** @summary Get */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAgentConfigParameters>
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>
    ): QueryState<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>, GetAgentConfigError> | undefined;
    /** @summary Get */
    setQueryData(
      parameters:
        | DeepReadonly<GetAgentConfigParameters>
        | ServiceOperationQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
      updater: Updater<NoInfer<GetAgentConfigData> | undefined, NoInfer<DeepReadonly<GetAgentConfigData>> | undefined>,
      options?: SetDataOptions
    ): GetAgentConfigData | undefined;
    /** @summary Get */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetAgentConfigParameters>
        | ServiceOperationInfiniteQueryKey<GetAgentConfigSchema, GetAgentConfigParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAgentConfigData, GetAgentConfigParameters> | undefined;
    /** @summary Get */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >,
      updater: Updater<NoInfer<GetAgentConfigData> | undefined, NoInfer<GetAgentConfigData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAgentConfigData | undefined>;
    /** @summary Get */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAgentConfigSchema,
        GetAgentConfigData,
        TInfinite,
        GetAgentConfigParameters,
        GetAgentConfigError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
    ): void;
    /** @summary Get */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
        | QueryFiltersByQueryKey<
            GetAgentConfigSchema,
            GetAgentConfigData,
            TInfinite,
            GetAgentConfigParameters,
            GetAgentConfigError
          >
    ): number;
    schema: GetAgentConfigSchema;
    types: {
      parameters: GetAgentConfigParameters;
      data: GetAgentConfigData;
      error: GetAgentConfigError;
    };
  };
  /** @summary Update */
  updateAgentConfig: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateAgentConfigBody, UpdateAgentConfigParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateAgentConfigSchema,
        options: ServiceOperationMutationFnOptions<UpdateAgentConfigBody, UpdateAgentConfigParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateAgentConfigData, UpdateAgentConfigError>>
    ): Promise<RequestFnResponse<UpdateAgentConfigData, UpdateAgentConfigError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateAgentConfigParameters> | void
    ): ServiceOperationMutationKey<UpdateAgentConfigSchema, UpdateAgentConfigParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateAgentConfig.useMutation({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateAgentConfig.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateAgentConfigBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateAgentConfigParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateAgentConfigSchema,
        UpdateAgentConfigData,
        UpdateAgentConfigParameters,
        TVariables,
        OperationError<UpdateAgentConfigError>,
        TContext
      >
    ): UseMutationResult<UpdateAgentConfigData, OperationError<UpdateAgentConfigError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateAgentConfig.useMutation({
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateAgentConfig.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         agent_config_id: agentConfigId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateAgentConfigSchema,
        UpdateAgentConfigData,
        UpdateAgentConfigParameters,
        TVariables,
        OperationError<UpdateAgentConfigError>,
        TContext
      >
    ): UseMutationResult<UpdateAgentConfigData, OperationError<UpdateAgentConfigError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateAgentConfigTotal = qraft.agentService.updateAgentConfig.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateAgentConfigTotal = qraft.agentService.updateAgentConfig.useIsMutating({
     *     parameters: {
     *         path: {
     *             agent_config_id: agentConfigId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateAgentConfigSchema,
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateAgentConfigPendingMutationVariables = qraft.agentService.updateAgentConfig.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateAgentConfigMutationData = qraft.agentService.updateAgentConfig.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 agent_config_id: agentConfigId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateAgentConfigData,
        OperationError<UpdateAgentConfigError>,
        MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateAgentConfigSchema,
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateAgentConfigData,
          OperationError<UpdateAgentConfigError>,
          MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateAgentConfigSchema,
            UpdateAgentConfigBody,
            UpdateAgentConfigData,
            UpdateAgentConfigParameters,
            OperationError<UpdateAgentConfigError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.updateAgentConfig.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             agent_config_id: agentConfigId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.updateAgentConfig.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateAgentConfigBody,
              UpdateAgentConfigData,
              UpdateAgentConfigParameters,
              OperationError<UpdateAgentConfigError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateAgentConfigSchema,
              UpdateAgentConfigBody,
              UpdateAgentConfigData,
              UpdateAgentConfigParameters,
              OperationError<UpdateAgentConfigError>,
              TContext
            >
      ):
        | Mutation<
            UpdateAgentConfigData,
            UpdateAgentConfigError,
            MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateAgentConfigBody,
              UpdateAgentConfigData,
              UpdateAgentConfigParameters,
              OperationError<UpdateAgentConfigError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateAgentConfigSchema,
              UpdateAgentConfigBody,
              UpdateAgentConfigData,
              UpdateAgentConfigParameters,
              OperationError<UpdateAgentConfigError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateAgentConfigData,
          UpdateAgentConfigError,
          MutationVariables<UpdateAgentConfigBody, UpdateAgentConfigParameters>,
          TContext
        >
      >;
    };
    schema: UpdateAgentConfigSchema;
    types: {
      parameters: UpdateAgentConfigParameters;
      data: UpdateAgentConfigData;
      error: UpdateAgentConfigError;
      body: UpdateAgentConfigBody;
    };
  };
  /** @summary List */
  listBlocks: {
    /** @summary List */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListBlocksSchema, ListBlocksParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListBlocksParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListBlocksSchema,
        options: {
          parameters: ListBlocksParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListBlocksData, ListBlocksError>>
    ): Promise<RequestFnResponse<ListBlocksData, ListBlocksError>>;
    /** @summary List */
    getQueryKey(
      parameters: DeepReadonly<ListBlocksParameters> | void
    ): ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.listBlocks.useQuery()
     * ```
     */
    useQuery<TData = ListBlocksData>(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListBlocksData,
          ListBlocksError,
          TData,
          ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListBlocksError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.listBlocks.useQuery()
     * ```
     */
    useQuery<TData = ListBlocksData>(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListBlocksData,
          ListBlocksError,
          TData,
          ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListBlocksError>>;
    /** @summary List */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListBlocksParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listBlocks.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListBlocksParameters,
      TQueryFnData = ListBlocksData,
      TData = OperationInfiniteData<TQueryFnData, ListBlocksParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListBlocksError,
          TData,
          ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListBlocksError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listBlocks.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListBlocksParameters,
      TQueryFnData = ListBlocksData,
      TData = OperationInfiniteData<TQueryFnData, ListBlocksParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListBlocksError,
          TData,
          ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListBlocksData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListBlocksError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listBlocksTotal = qraft.agentService.listBlocks.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listBlocksResults = qraft.agentService.listBlocks.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listBlocksResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listBlocksCombinedResults = qraft.agentService.listBlocks.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listBlocksCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<ListBlocksSchema, ListBlocksParameters, ListBlocksData, ListBlocksError>
      >,
      TCombinedResult = Array<UseQueryResult<ListBlocksData, ListBlocksError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListBlocksData, ListBlocksError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentService.listBlocks.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListBlocksData>(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListBlocksData,
          ListBlocksError,
          TData,
          ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListBlocksError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.listBlocks.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListBlocksParameters, TData = ListBlocksData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListBlocksData,
          ListBlocksError,
          OperationInfiniteData<TData, ListBlocksParameters>,
          ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListBlocksData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListBlocksParameters>,
      OperationError<ListBlocksError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listBlocksData = qraft.agentService.listBlocks.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listBlocksResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listBlocksCombinedData = qraft.agentService.listBlocks.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listBlocksCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<ListBlocksSchema, ListBlocksParameters, ListBlocksData, ListBlocksError>
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListBlocksData, ListBlocksError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListBlocksData, ListBlocksError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        ListBlocksError
      > | void
    ): Promise<ListBlocksData>;
    /** @summary List */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        ListBlocksError
      > | void
    ): Promise<void>;
    /** @summary List */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        ListBlocksError
      > | void
    ): Promise<ListBlocksData>;
    /** @summary List */
    fetchInfiniteQuery<TPageParam extends ListBlocksParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        DeepReadonly<TPageParam>,
        ListBlocksError
      > | void
    ): Promise<OperationInfiniteData<ListBlocksData, ListBlocksParameters>>;
    /** @summary List */
    prefetchInfiniteQuery<TPageParam extends ListBlocksParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        DeepReadonly<TPageParam>,
        ListBlocksError
      > | void
    ): Promise<void>;
    /** @summary List */
    ensureInfiniteQueryData<TPageParam extends ListBlocksParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        DeepReadonly<TPageParam>,
        ListBlocksError
      > | void
    ): Promise<OperationInfiniteData<ListBlocksData, ListBlocksParameters>>;
    /** @summary List */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void)
    ): ListBlocksData | undefined;
    /** @summary List */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void)
    ): OperationInfiniteData<ListBlocksData, ListBlocksParameters> | undefined;
    /** @summary List */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
            data: NoInfer<OperationInfiniteData<ListBlocksData, ListBlocksParameters>> | undefined,
          ]
        >
      : Array<
          [queryKey: ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>, data: ListBlocksData | undefined]
        >;
    /** @summary List */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void)
    ): QueryState<ListBlocksData, ListBlocksError> | undefined;
    /** @summary List */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListBlocksParameters>
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | void
    ): QueryState<OperationInfiniteData<ListBlocksData, ListBlocksParameters>, ListBlocksError> | undefined;
    /** @summary List */
    setQueryData(
      parameters:
        | (DeepReadonly<ListBlocksParameters> | undefined)
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>,
      updater: Updater<NoInfer<ListBlocksData> | undefined, NoInfer<DeepReadonly<ListBlocksData>> | undefined>,
      options?: SetDataOptions
    ): ListBlocksData | undefined;
    /** @summary List */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListBlocksParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListBlocksData, ListBlocksParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListBlocksData, ListBlocksParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListBlocksData, ListBlocksParameters> | undefined;
    /** @summary List */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>,
      updater: Updater<NoInfer<ListBlocksData> | undefined, NoInfer<ListBlocksData> | undefined>,
      options?: SetDataOptions
    ): Array<ListBlocksData | undefined>;
    /** @summary List */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListBlocksSchema,
        ListBlocksData,
        TInfinite,
        ListBlocksParameters,
        ListBlocksError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
    ): void;
    /** @summary List */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
    ): number;
    schema: ListBlocksSchema;
    types: {
      parameters: ListBlocksParameters;
      data: ListBlocksData;
      error: ListBlocksError;
    };
  };
  /** @summary Create */
  createBlock: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateBlockBody, CreateBlockParameters, TMeta, TSignal>,
      client?: (
        schema: CreateBlockSchema,
        options: ServiceOperationMutationFnOptions<CreateBlockBody, CreateBlockParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateBlockData, CreateBlockError>>
    ): Promise<RequestFnResponse<CreateBlockData, CreateBlockError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateBlockParameters> | void
    ): ServiceOperationMutationKey<CreateBlockSchema, CreateBlockParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createBlock.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createBlock.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateBlockBody, TContext = unknown>(
      parameters: DeepReadonly<CreateBlockParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateBlockSchema,
        CreateBlockData,
        CreateBlockParameters,
        TVariables,
        OperationError<CreateBlockError>,
        TContext
      >
    ): UseMutationResult<CreateBlockData, OperationError<CreateBlockError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createBlock.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createBlock.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<CreateBlockBody, CreateBlockParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateBlockSchema,
        CreateBlockData,
        CreateBlockParameters,
        TVariables,
        OperationError<CreateBlockError>,
        TContext
      >
    ): UseMutationResult<CreateBlockData, OperationError<CreateBlockError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createBlockTotal = qraft.agentService.createBlock.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createBlockTotal = qraft.agentService.createBlock.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateBlockSchema,
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createBlockPendingMutationVariables = qraft.agentService.createBlock.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createBlockMutationData = qraft.agentService.createBlock.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateBlockData,
        OperationError<CreateBlockError>,
        MutationVariables<CreateBlockBody, CreateBlockParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateBlockSchema,
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateBlockData,
          OperationError<CreateBlockError>,
          MutationVariables<CreateBlockBody, CreateBlockParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateBlockSchema,
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.createBlock.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.createBlock.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateBlockBody,
              CreateBlockData,
              CreateBlockParameters,
              OperationError<CreateBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateBlockSchema,
              CreateBlockBody,
              CreateBlockData,
              CreateBlockParameters,
              OperationError<CreateBlockError>,
              TContext
            >
      ):
        | Mutation<
            CreateBlockData,
            CreateBlockError,
            MutationVariables<CreateBlockBody, CreateBlockParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateBlockBody,
              CreateBlockData,
              CreateBlockParameters,
              OperationError<CreateBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateBlockSchema,
              CreateBlockBody,
              CreateBlockData,
              CreateBlockParameters,
              OperationError<CreateBlockError>,
              TContext
            >
      ): Array<
        Mutation<CreateBlockData, CreateBlockError, MutationVariables<CreateBlockBody, CreateBlockParameters>, TContext>
      >;
    };
    schema: CreateBlockSchema;
    types: {
      parameters: CreateBlockParameters;
      data: CreateBlockData;
      error: CreateBlockError;
      body: CreateBlockBody;
    };
  };
  /** @summary Template Context */
  getTemplateContext: {
    /** @summary Template Context */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetTemplateContextSchema, GetTemplateContextParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetTemplateContextParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetTemplateContextSchema,
        options: {
          parameters: GetTemplateContextParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetTemplateContextData, GetTemplateContextError>>
    ): Promise<RequestFnResponse<GetTemplateContextData, GetTemplateContextError>>;
    /** @summary Template Context */
    getQueryKey(
      parameters: DeepReadonly<GetTemplateContextParameters> | void
    ): ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.getTemplateContext.useQuery()
     * ```
     */
    useQuery<TData = GetTemplateContextData>(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetTemplateContextData,
          GetTemplateContextError,
          TData,
          ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetTemplateContextError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentService.getTemplateContext.useQuery()
     * ```
     */
    useQuery<TData = GetTemplateContextData>(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetTemplateContextData,
          GetTemplateContextError,
          TData,
          ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetTemplateContextError>>;
    /** @summary Template Context */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetTemplateContextParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.getTemplateContext.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTemplateContextParameters,
      TQueryFnData = GetTemplateContextData,
      TData = OperationInfiniteData<TQueryFnData, GetTemplateContextParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTemplateContextError,
          TData,
          ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetTemplateContextError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.getTemplateContext.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTemplateContextParameters,
      TQueryFnData = GetTemplateContextData,
      TData = OperationInfiniteData<TQueryFnData, GetTemplateContextParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTemplateContextError,
          TData,
          ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetTemplateContextData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetTemplateContextError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getTemplateContextTotal = qraft.agentService.getTemplateContext.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getTemplateContextResults = qraft.agentService.getTemplateContext.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getTemplateContextResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getTemplateContextCombinedResults = qraft.agentService.getTemplateContext.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getTemplateContextCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetTemplateContextSchema,
          GetTemplateContextParameters,
          GetTemplateContextData,
          GetTemplateContextError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetTemplateContextData, GetTemplateContextError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetTemplateContextData, GetTemplateContextError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentService.getTemplateContext.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetTemplateContextData>(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetTemplateContextData,
          GetTemplateContextError,
          TData,
          ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetTemplateContextError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentService.getTemplateContext.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetTemplateContextParameters, TData = GetTemplateContextData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetTemplateContextData,
          GetTemplateContextError,
          OperationInfiniteData<TData, GetTemplateContextParameters>,
          ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetTemplateContextData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetTemplateContextParameters>,
      OperationError<GetTemplateContextError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getTemplateContextData = qraft.agentService.getTemplateContext.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getTemplateContextResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getTemplateContextCombinedData = qraft.agentService.getTemplateContext.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getTemplateContextCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetTemplateContextSchema,
          GetTemplateContextParameters,
          GetTemplateContextData,
          GetTemplateContextError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetTemplateContextData, GetTemplateContextError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetTemplateContextData, GetTemplateContextError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Template Context */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        GetTemplateContextError
      > | void
    ): Promise<GetTemplateContextData>;
    /** @summary Template Context */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        GetTemplateContextError
      > | void
    ): Promise<void>;
    /** @summary Template Context */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        GetTemplateContextError
      > | void
    ): Promise<GetTemplateContextData>;
    /** @summary Template Context */
    fetchInfiniteQuery<TPageParam extends GetTemplateContextParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        DeepReadonly<TPageParam>,
        GetTemplateContextError
      > | void
    ): Promise<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>>;
    /** @summary Template Context */
    prefetchInfiniteQuery<TPageParam extends GetTemplateContextParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        DeepReadonly<TPageParam>,
        GetTemplateContextError
      > | void
    ): Promise<void>;
    /** @summary Template Context */
    ensureInfiniteQueryData<TPageParam extends GetTemplateContextParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        DeepReadonly<TPageParam>,
        GetTemplateContextError
      > | void
    ): Promise<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>>;
    /** @summary Template Context */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void)
    ): GetTemplateContextData | undefined;
    /** @summary Template Context */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void)
    ): OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters> | undefined;
    /** @summary Template Context */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
            data: NoInfer<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
            data: GetTemplateContextData | undefined,
          ]
        >;
    /** @summary Template Context */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void)
    ): QueryState<GetTemplateContextData, GetTemplateContextError> | undefined;
    /** @summary Template Context */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetTemplateContextParameters>
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>, GetTemplateContextError>
      | undefined;
    /** @summary Template Context */
    setQueryData(
      parameters:
        | (DeepReadonly<GetTemplateContextParameters> | undefined)
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
      updater: Updater<
        NoInfer<GetTemplateContextData> | undefined,
        NoInfer<DeepReadonly<GetTemplateContextData>> | undefined
      >,
      options?: SetDataOptions
    ): GetTemplateContextData | undefined;
    /** @summary Template Context */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetTemplateContextParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters> | undefined;
    /** @summary Template Context */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >,
      updater: Updater<NoInfer<GetTemplateContextData> | undefined, NoInfer<GetTemplateContextData> | undefined>,
      options?: SetDataOptions
    ): Array<GetTemplateContextData | undefined>;
    /** @summary Template Context */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetTemplateContextSchema,
        GetTemplateContextData,
        TInfinite,
        GetTemplateContextParameters,
        GetTemplateContextError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Template Context */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Template Context */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Template Context */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
    ): void;
    /** @summary Template Context */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Template Context */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
    ): number;
    schema: GetTemplateContextSchema;
    types: {
      parameters: GetTemplateContextParameters;
      data: GetTemplateContextData;
      error: GetTemplateContextError;
    };
  };
  /** @summary Preview */
  previewBlock: {
    /** @summary Preview */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<PreviewBlockBody, PreviewBlockParameters, TMeta, TSignal>,
      client?: (
        schema: PreviewBlockSchema,
        options: ServiceOperationMutationFnOptions<PreviewBlockBody, PreviewBlockParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<PreviewBlockData, PreviewBlockError>>
    ): Promise<RequestFnResponse<PreviewBlockData, PreviewBlockError>>;
    /** @summary Preview */
    getMutationKey(
      parameters: DeepReadonly<PreviewBlockParameters> | void
    ): ServiceOperationMutationKey<PreviewBlockSchema, PreviewBlockParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.previewBlock.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.previewBlock.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends PreviewBlockBody, TContext = unknown>(
      parameters: DeepReadonly<PreviewBlockParameters>,
      options?: ServiceOperationUseMutationOptions<
        PreviewBlockSchema,
        PreviewBlockData,
        PreviewBlockParameters,
        TVariables,
        OperationError<PreviewBlockError>,
        TContext
      >
    ): UseMutationResult<PreviewBlockData, OperationError<PreviewBlockError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.previewBlock.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.previewBlock.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<PreviewBlockBody, PreviewBlockParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        PreviewBlockSchema,
        PreviewBlockData,
        PreviewBlockParameters,
        TVariables,
        OperationError<PreviewBlockError>,
        TContext
      >
    ): UseMutationResult<PreviewBlockData, OperationError<PreviewBlockError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const previewBlockTotal = qraft.agentService.previewBlock.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const previewBlockTotal = qraft.agentService.previewBlock.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewBlockSchema,
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const previewBlockPendingMutationVariables = qraft.agentService.previewBlock.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const previewBlockMutationData = qraft.agentService.previewBlock.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        PreviewBlockData,
        OperationError<PreviewBlockError>,
        MutationVariables<PreviewBlockBody, PreviewBlockParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewBlockSchema,
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          PreviewBlockData,
          OperationError<PreviewBlockError>,
          MutationVariables<PreviewBlockBody, PreviewBlockParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Preview */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewBlockSchema,
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.previewBlock.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.previewBlock.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              PreviewBlockBody,
              PreviewBlockData,
              PreviewBlockParameters,
              OperationError<PreviewBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewBlockSchema,
              PreviewBlockBody,
              PreviewBlockData,
              PreviewBlockParameters,
              OperationError<PreviewBlockError>,
              TContext
            >
      ):
        | Mutation<
            PreviewBlockData,
            PreviewBlockError,
            MutationVariables<PreviewBlockBody, PreviewBlockParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              PreviewBlockBody,
              PreviewBlockData,
              PreviewBlockParameters,
              OperationError<PreviewBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewBlockSchema,
              PreviewBlockBody,
              PreviewBlockData,
              PreviewBlockParameters,
              OperationError<PreviewBlockError>,
              TContext
            >
      ): Array<
        Mutation<
          PreviewBlockData,
          PreviewBlockError,
          MutationVariables<PreviewBlockBody, PreviewBlockParameters>,
          TContext
        >
      >;
    };
    schema: PreviewBlockSchema;
    types: {
      parameters: PreviewBlockParameters;
      data: PreviewBlockData;
      error: PreviewBlockError;
      body: PreviewBlockBody;
    };
  };
  /** @summary Update */
  updateBlock: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateBlockBody, UpdateBlockParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateBlockSchema,
        options: ServiceOperationMutationFnOptions<UpdateBlockBody, UpdateBlockParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateBlockData, UpdateBlockError>>
    ): Promise<RequestFnResponse<UpdateBlockData, UpdateBlockError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateBlockParameters> | void
    ): ServiceOperationMutationKey<UpdateBlockSchema, UpdateBlockParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateBlock.useMutation({
     *     path: {
     *         block_id: blockId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateBlock.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         block_id: blockId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateBlockBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateBlockParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateBlockSchema,
        UpdateBlockData,
        UpdateBlockParameters,
        TVariables,
        OperationError<UpdateBlockError>,
        TContext
      >
    ): UseMutationResult<UpdateBlockData, OperationError<UpdateBlockError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateBlock.useMutation({
     *     path: {
     *         block_id: blockId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.updateBlock.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         block_id: blockId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<UpdateBlockBody, UpdateBlockParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateBlockSchema,
        UpdateBlockData,
        UpdateBlockParameters,
        TVariables,
        OperationError<UpdateBlockError>,
        TContext
      >
    ): UseMutationResult<UpdateBlockData, OperationError<UpdateBlockError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateBlockTotal = qraft.agentService.updateBlock.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateBlockTotal = qraft.agentService.updateBlock.useIsMutating({
     *     parameters: {
     *         path: {
     *             block_id: blockId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateBlockSchema,
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateBlockPendingMutationVariables = qraft.agentService.updateBlock.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateBlockMutationData = qraft.agentService.updateBlock.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 block_id: blockId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateBlockData,
        OperationError<UpdateBlockError>,
        MutationVariables<UpdateBlockBody, UpdateBlockParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateBlockSchema,
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateBlockData,
          OperationError<UpdateBlockError>,
          MutationVariables<UpdateBlockBody, UpdateBlockParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateBlockSchema,
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.updateBlock.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             block_id: blockId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.updateBlock.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateBlockBody,
              UpdateBlockData,
              UpdateBlockParameters,
              OperationError<UpdateBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateBlockSchema,
              UpdateBlockBody,
              UpdateBlockData,
              UpdateBlockParameters,
              OperationError<UpdateBlockError>,
              TContext
            >
      ):
        | Mutation<
            UpdateBlockData,
            UpdateBlockError,
            MutationVariables<UpdateBlockBody, UpdateBlockParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateBlockBody,
              UpdateBlockData,
              UpdateBlockParameters,
              OperationError<UpdateBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateBlockSchema,
              UpdateBlockBody,
              UpdateBlockData,
              UpdateBlockParameters,
              OperationError<UpdateBlockError>,
              TContext
            >
      ): Array<
        Mutation<UpdateBlockData, UpdateBlockError, MutationVariables<UpdateBlockBody, UpdateBlockParameters>, TContext>
      >;
    };
    schema: UpdateBlockSchema;
    types: {
      parameters: UpdateBlockParameters;
      data: UpdateBlockData;
      error: UpdateBlockError;
      body: UpdateBlockBody;
    };
  };
  /**
   * @summary Get Customers By Phone Endpoint
   * @description Get customers by phone number.
   *
   * Search for customers using their phone number. The phone number will be validated
   * and normalized to E164 format before searching.
   *
   * For testing in FastAPI docs:
   * 1. Ensure you have a valid retell_agent_id in the voice_agents table
   * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
   */
  getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost: {
    /**
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
        options: ServiceOperationMutationFnOptions<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError
      >
    >;
    /**
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     */
    getMutationKey(
      parameters: DeepReadonly<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters> | void
    ): ServiceOperationMutationKey<
      GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
      GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody, TContext = unknown>(
      parameters: DeepReadonly<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
        TVariables,
        OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
        TContext
      >
    ): UseMutationResult<
      GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
      OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
        TVariables,
        OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
        TContext
      >
    ): UseMutationResult<
      GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
      OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostTotal = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostTotal = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostPendingMutationVariables = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostMutationData = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
        OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
        MutationVariables<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
          OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
          MutationVariables<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
              OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
              OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
              TContext
            >
      ):
        | Mutation<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError,
            MutationVariables<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
              OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
              OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
              TContext
            >
      ): Array<
        Mutation<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError,
          MutationVariables<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
          >,
          TContext
        >
      >;
    };
    schema: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema;
    types: {
      parameters: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters;
      data: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData;
      error: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError;
      body: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody;
    };
  };
  /**
   * @summary Get Customers By Zipcode Endpoint
   * @description Get customers by zipcode.
   *
   * Search for all customers in a specific ZIP code area.
   */
  getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost: {
    /**
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
        options: ServiceOperationMutationFnOptions<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError
      >
    >;
    /**
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     */
    getMutationKey(
      parameters: DeepReadonly<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters> | void
    ): ServiceOperationMutationKey<
      GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
      GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
        TVariables,
        OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
        TContext
      >
    ): UseMutationResult<
      GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
      OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
        TVariables,
        OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
        TContext
      >
    ): UseMutationResult<
      GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
      OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostTotal = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostTotal = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostPendingMutationVariables = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostMutationData = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
        OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
        MutationVariables<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
          OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
          MutationVariables<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
              OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
              OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
              TContext
            >
      ):
        | Mutation<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError,
            MutationVariables<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
              OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
              OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
              TContext
            >
      ): Array<
        Mutation<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError,
          MutationVariables<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
          >,
          TContext
        >
      >;
    };
    schema: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema;
    types: {
      parameters: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters;
      data: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData;
      error: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError;
      body: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody;
    };
  };
  /**
   * @summary Search Customers By Address Endpoint
   * @description Search customers by address with fuzzy matching.
   *
   * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
   * Returns exact matches and similar addresses with similarity scores.
   */
  searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost: {
    /**
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
        options: ServiceOperationMutationFnOptions<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError
      >
    >;
    /**
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     */
    getMutationKey(
      parameters: DeepReadonly<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters> | void
    ): ServiceOperationMutationKey<
      SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
      SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
        TVariables,
        OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
        TContext
      >
    ): UseMutationResult<
      SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
      OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
        TVariables,
        OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
        TContext
      >
    ): UseMutationResult<
      SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
      OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostTotal = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostTotal = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostPendingMutationVariables = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostMutationData = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
        OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
        MutationVariables<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
          OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
          MutationVariables<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
              OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
              OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
              TContext
            >
      ):
        | Mutation<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError,
            MutationVariables<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
              OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
              OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
              TContext
            >
      ): Array<
        Mutation<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError,
          MutationVariables<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
          >,
          TContext
        >
      >;
    };
    schema: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema;
    types: {
      parameters: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters;
      data: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData;
      error: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError;
      body: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody;
    };
  };
  /**
   * @summary Create Customer Endpoint
   * @description Create a new customer.
   *
   * Creates a new customer with contact information and optional address.
   */
  createCustomerEndpointAgentToolCustomerCreatePost: {
    /**
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateCustomerEndpointAgentToolCustomerCreatePostBody,
        CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateCustomerEndpointAgentToolCustomerCreatePostBody,
          CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateCustomerEndpointAgentToolCustomerCreatePostData,
          CreateCustomerEndpointAgentToolCustomerCreatePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CreateCustomerEndpointAgentToolCustomerCreatePostData,
        CreateCustomerEndpointAgentToolCustomerCreatePostError
      >
    >;
    /**
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateCustomerEndpointAgentToolCustomerCreatePostParameters> | void
    ): ServiceOperationMutationKey<
      CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
      CreateCustomerEndpointAgentToolCustomerCreatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateCustomerEndpointAgentToolCustomerCreatePostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateCustomerEndpointAgentToolCustomerCreatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
        CreateCustomerEndpointAgentToolCustomerCreatePostData,
        CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
        TVariables,
        OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
        TContext
      >
    ): UseMutationResult<
      CreateCustomerEndpointAgentToolCustomerCreatePostData,
      OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateCustomerEndpointAgentToolCustomerCreatePostBody,
        CreateCustomerEndpointAgentToolCustomerCreatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
        CreateCustomerEndpointAgentToolCustomerCreatePostData,
        CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
        TVariables,
        OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
        TContext
      >
    ): UseMutationResult<
      CreateCustomerEndpointAgentToolCustomerCreatePostData,
      OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createCustomerEndpointAgentToolCustomerCreatePostTotal = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createCustomerEndpointAgentToolCustomerCreatePostTotal = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createCustomerEndpointAgentToolCustomerCreatePostPendingMutationVariables = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createCustomerEndpointAgentToolCustomerCreatePostMutationData = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateCustomerEndpointAgentToolCustomerCreatePostData,
        OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
        MutationVariables<
          CreateCustomerEndpointAgentToolCustomerCreatePostBody,
          CreateCustomerEndpointAgentToolCustomerCreatePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateCustomerEndpointAgentToolCustomerCreatePostData,
          OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
          MutationVariables<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.createCustomerEndpointAgentToolCustomerCreatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostData,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
              OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostData,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
              OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
              TContext
            >
      ):
        | Mutation<
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostError,
            MutationVariables<
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostData,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
              OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostData,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
              OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateCustomerEndpointAgentToolCustomerCreatePostData,
          CreateCustomerEndpointAgentToolCustomerCreatePostError,
          MutationVariables<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateCustomerEndpointAgentToolCustomerCreatePostSchema;
    types: {
      parameters: CreateCustomerEndpointAgentToolCustomerCreatePostParameters;
      data: CreateCustomerEndpointAgentToolCustomerCreatePostData;
      error: CreateCustomerEndpointAgentToolCustomerCreatePostError;
      body: CreateCustomerEndpointAgentToolCustomerCreatePostBody;
    };
  };
  /**
   * @summary Get Availability Endpoint
   * @description Get available appointment slots for a customer and service type.
   */
  getAvailabilityEndpointAgentToolAvailabilityListPost: {
    /**
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
        GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
        options: ServiceOperationMutationFnOptions<
          GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
          GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          GetAvailabilityEndpointAgentToolAvailabilityListPostData,
          GetAvailabilityEndpointAgentToolAvailabilityListPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetAvailabilityEndpointAgentToolAvailabilityListPostData,
        GetAvailabilityEndpointAgentToolAvailabilityListPostError
      >
    >;
    /**
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     */
    getMutationKey(
      parameters: DeepReadonly<GetAvailabilityEndpointAgentToolAvailabilityListPostParameters> | void
    ): ServiceOperationMutationKey<
      GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
      GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends GetAvailabilityEndpointAgentToolAvailabilityListPostBody, TContext = unknown>(
      parameters: DeepReadonly<GetAvailabilityEndpointAgentToolAvailabilityListPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
        GetAvailabilityEndpointAgentToolAvailabilityListPostData,
        GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
        TVariables,
        OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
        TContext
      >
    ): UseMutationResult<
      GetAvailabilityEndpointAgentToolAvailabilityListPostData,
      OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
        GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
        GetAvailabilityEndpointAgentToolAvailabilityListPostData,
        GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
        TVariables,
        OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
        TContext
      >
    ): UseMutationResult<
      GetAvailabilityEndpointAgentToolAvailabilityListPostData,
      OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const getAvailabilityEndpointAgentToolAvailabilityListPostTotal = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const getAvailabilityEndpointAgentToolAvailabilityListPostTotal = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const getAvailabilityEndpointAgentToolAvailabilityListPostPendingMutationVariables = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const getAvailabilityEndpointAgentToolAvailabilityListPostMutationData = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        GetAvailabilityEndpointAgentToolAvailabilityListPostData,
        OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
        MutationVariables<
          GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
          GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          GetAvailabilityEndpointAgentToolAvailabilityListPostData,
          OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
          MutationVariables<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.getAvailabilityEndpointAgentToolAvailabilityListPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostData,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
              OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostData,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
              OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
              TContext
            >
      ):
        | Mutation<
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostError,
            MutationVariables<
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostData,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
              OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostData,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
              OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
              TContext
            >
      ): Array<
        Mutation<
          GetAvailabilityEndpointAgentToolAvailabilityListPostData,
          GetAvailabilityEndpointAgentToolAvailabilityListPostError,
          MutationVariables<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
          >,
          TContext
        >
      >;
    };
    schema: GetAvailabilityEndpointAgentToolAvailabilityListPostSchema;
    types: {
      parameters: GetAvailabilityEndpointAgentToolAvailabilityListPostParameters;
      data: GetAvailabilityEndpointAgentToolAvailabilityListPostData;
      error: GetAvailabilityEndpointAgentToolAvailabilityListPostError;
      body: GetAvailabilityEndpointAgentToolAvailabilityListPostBody;
    };
  };
  /**
   * @summary List Appointments Endpoint
   * @description List appointments for a customer.
   */
  listAppointmentsEndpointAgentToolAppointmentListPost: {
    /**
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ListAppointmentsEndpointAgentToolAppointmentListPostBody,
        ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
        options: ServiceOperationMutationFnOptions<
          ListAppointmentsEndpointAgentToolAppointmentListPostBody,
          ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          ListAppointmentsEndpointAgentToolAppointmentListPostData,
          ListAppointmentsEndpointAgentToolAppointmentListPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListAppointmentsEndpointAgentToolAppointmentListPostData,
        ListAppointmentsEndpointAgentToolAppointmentListPostError
      >
    >;
    /**
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<ListAppointmentsEndpointAgentToolAppointmentListPostParameters> | void
    ): ServiceOperationMutationKey<
      ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
      ListAppointmentsEndpointAgentToolAppointmentListPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends ListAppointmentsEndpointAgentToolAppointmentListPostBody, TContext = unknown>(
      parameters: DeepReadonly<ListAppointmentsEndpointAgentToolAppointmentListPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
        ListAppointmentsEndpointAgentToolAppointmentListPostData,
        ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
        TVariables,
        OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
        TContext
      >
    ): UseMutationResult<
      ListAppointmentsEndpointAgentToolAppointmentListPostData,
      OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        ListAppointmentsEndpointAgentToolAppointmentListPostBody,
        ListAppointmentsEndpointAgentToolAppointmentListPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
        ListAppointmentsEndpointAgentToolAppointmentListPostData,
        ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
        TVariables,
        OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
        TContext
      >
    ): UseMutationResult<
      ListAppointmentsEndpointAgentToolAppointmentListPostData,
      OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const listAppointmentsEndpointAgentToolAppointmentListPostTotal = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const listAppointmentsEndpointAgentToolAppointmentListPostTotal = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const listAppointmentsEndpointAgentToolAppointmentListPostPendingMutationVariables = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const listAppointmentsEndpointAgentToolAppointmentListPostMutationData = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ListAppointmentsEndpointAgentToolAppointmentListPostData,
        OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
        MutationVariables<
          ListAppointmentsEndpointAgentToolAppointmentListPostBody,
          ListAppointmentsEndpointAgentToolAppointmentListPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ListAppointmentsEndpointAgentToolAppointmentListPostData,
          OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
          MutationVariables<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.listAppointmentsEndpointAgentToolAppointmentListPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostData,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
              OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostData,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
              OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
              TContext
            >
      ):
        | Mutation<
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostError,
            MutationVariables<
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostData,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
              OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostData,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
              OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
              TContext
            >
      ): Array<
        Mutation<
          ListAppointmentsEndpointAgentToolAppointmentListPostData,
          ListAppointmentsEndpointAgentToolAppointmentListPostError,
          MutationVariables<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters
          >,
          TContext
        >
      >;
    };
    schema: ListAppointmentsEndpointAgentToolAppointmentListPostSchema;
    types: {
      parameters: ListAppointmentsEndpointAgentToolAppointmentListPostParameters;
      data: ListAppointmentsEndpointAgentToolAppointmentListPostData;
      error: ListAppointmentsEndpointAgentToolAppointmentListPostError;
      body: ListAppointmentsEndpointAgentToolAppointmentListPostBody;
    };
  };
  /**
   * @summary List Past Appointments Endpoint
   * @description List past appointments for a customer.
   */
  listPastAppointmentsEndpointAgentToolAppointmentListPastPost: {
    /**
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
        options: ServiceOperationMutationFnOptions<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError
      >
    >;
    /**
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters> | void
    ): ServiceOperationMutationKey<
      ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
      ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
        TVariables,
        OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
        TContext
      >
    ): UseMutationResult<
      ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
      OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
        TVariables,
        OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
        TContext
      >
    ): UseMutationResult<
      ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
      OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const listPastAppointmentsEndpointAgentToolAppointmentListPastPostTotal = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const listPastAppointmentsEndpointAgentToolAppointmentListPastPostTotal = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const listPastAppointmentsEndpointAgentToolAppointmentListPastPostPendingMutationVariables = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const listPastAppointmentsEndpointAgentToolAppointmentListPastPostMutationData = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
        OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
        MutationVariables<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
          OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
          MutationVariables<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
              OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
              OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
              TContext
            >
      ):
        | Mutation<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError,
            MutationVariables<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
              OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
              OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
              TContext
            >
      ): Array<
        Mutation<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError,
          MutationVariables<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
          >,
          TContext
        >
      >;
    };
    schema: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema;
    types: {
      parameters: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters;
      data: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData;
      error: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError;
      body: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody;
    };
  };
  /**
   * @summary List Upcoming Appointments Endpoint
   * @description List upcoming appointments for a customer.
   */
  listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost: {
    /**
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
        options: ServiceOperationMutationFnOptions<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError
      >
    >;
    /**
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters> | void
    ): ServiceOperationMutationKey<
      ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
      ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
        TVariables,
        OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
        TContext
      >
    ): UseMutationResult<
      ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
      OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
        TVariables,
        OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
        TContext
      >
    ): UseMutationResult<
      ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
      OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostTotal = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostTotal = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostPendingMutationVariables = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostMutationData = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
        OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
        MutationVariables<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
          OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
          MutationVariables<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
              OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
              OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
              TContext
            >
      ):
        | Mutation<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError,
            MutationVariables<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
              OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
              OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
              TContext
            >
      ): Array<
        Mutation<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError,
          MutationVariables<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
          >,
          TContext
        >
      >;
    };
    schema: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema;
    types: {
      parameters: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters;
      data: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData;
      error: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError;
      body: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody;
    };
  };
  /**
   * @summary Book Appointment Endpoint
   * @description Book a new appointment for a customer.
   */
  bookAppointmentEndpointAgentToolAppointmentBookPost: {
    /**
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        BookAppointmentEndpointAgentToolAppointmentBookPostBody,
        BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
        options: ServiceOperationMutationFnOptions<
          BookAppointmentEndpointAgentToolAppointmentBookPostBody,
          BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          BookAppointmentEndpointAgentToolAppointmentBookPostData,
          BookAppointmentEndpointAgentToolAppointmentBookPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        BookAppointmentEndpointAgentToolAppointmentBookPostData,
        BookAppointmentEndpointAgentToolAppointmentBookPostError
      >
    >;
    /**
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<BookAppointmentEndpointAgentToolAppointmentBookPostParameters> | void
    ): ServiceOperationMutationKey<
      BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
      BookAppointmentEndpointAgentToolAppointmentBookPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends BookAppointmentEndpointAgentToolAppointmentBookPostBody, TContext = unknown>(
      parameters: DeepReadonly<BookAppointmentEndpointAgentToolAppointmentBookPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
        BookAppointmentEndpointAgentToolAppointmentBookPostData,
        BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
        TVariables,
        OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
        TContext
      >
    ): UseMutationResult<
      BookAppointmentEndpointAgentToolAppointmentBookPostData,
      OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        BookAppointmentEndpointAgentToolAppointmentBookPostBody,
        BookAppointmentEndpointAgentToolAppointmentBookPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
        BookAppointmentEndpointAgentToolAppointmentBookPostData,
        BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
        TVariables,
        OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
        TContext
      >
    ): UseMutationResult<
      BookAppointmentEndpointAgentToolAppointmentBookPostData,
      OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const bookAppointmentEndpointAgentToolAppointmentBookPostTotal = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const bookAppointmentEndpointAgentToolAppointmentBookPostTotal = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const bookAppointmentEndpointAgentToolAppointmentBookPostPendingMutationVariables = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const bookAppointmentEndpointAgentToolAppointmentBookPostMutationData = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        BookAppointmentEndpointAgentToolAppointmentBookPostData,
        OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
        MutationVariables<
          BookAppointmentEndpointAgentToolAppointmentBookPostBody,
          BookAppointmentEndpointAgentToolAppointmentBookPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          BookAppointmentEndpointAgentToolAppointmentBookPostData,
          OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
          MutationVariables<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.bookAppointmentEndpointAgentToolAppointmentBookPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostData,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
              OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostData,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
              OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
              TContext
            >
      ):
        | Mutation<
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostError,
            MutationVariables<
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostData,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
              OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostData,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
              OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
              TContext
            >
      ): Array<
        Mutation<
          BookAppointmentEndpointAgentToolAppointmentBookPostData,
          BookAppointmentEndpointAgentToolAppointmentBookPostError,
          MutationVariables<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters
          >,
          TContext
        >
      >;
    };
    schema: BookAppointmentEndpointAgentToolAppointmentBookPostSchema;
    types: {
      parameters: BookAppointmentEndpointAgentToolAppointmentBookPostParameters;
      data: BookAppointmentEndpointAgentToolAppointmentBookPostData;
      error: BookAppointmentEndpointAgentToolAppointmentBookPostError;
      body: BookAppointmentEndpointAgentToolAppointmentBookPostBody;
    };
  };
  /**
   * @summary Reschedule Appointment Endpoint
   * @description Reschedule an existing appointment.
   */
  rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost: {
    /**
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
        options: ServiceOperationMutationFnOptions<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError
      >
    >;
    /**
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     */
    getMutationKey(
      parameters: DeepReadonly<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters> | void
    ): ServiceOperationMutationKey<
      RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
      RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
        TVariables,
        OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
        TContext
      >
    ): UseMutationResult<
      RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
      OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
        TVariables,
        OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
        TContext
      >
    ): UseMutationResult<
      RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
      OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePostTotal = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePostTotal = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePostPendingMutationVariables = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePostMutationData = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
        OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
        MutationVariables<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
          OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
          MutationVariables<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
              OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
              OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
              TContext
            >
      ):
        | Mutation<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError,
            MutationVariables<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
              OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
              OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
              TContext
            >
      ): Array<
        Mutation<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError,
          MutationVariables<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
          >,
          TContext
        >
      >;
    };
    schema: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema;
    types: {
      parameters: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters;
      data: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData;
      error: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError;
      body: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody;
    };
  };
  /**
   * @summary Cancel Appointment Endpoint
   * @description Cancel an appointment.
   */
  cancelAppointmentEndpointAgentToolAppointmentCancelPost: {
    /**
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
        options: ServiceOperationMutationFnOptions<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
          CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
          CancelAppointmentEndpointAgentToolAppointmentCancelPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostError
      >
    >;
    /**
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     */
    getMutationKey(
      parameters: DeepReadonly<CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters> | void
    ): ServiceOperationMutationKey<
      CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
      CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CancelAppointmentEndpointAgentToolAppointmentCancelPostBody, TContext = unknown>(
      parameters: DeepReadonly<CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
        TVariables,
        OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
        TContext
      >
    ): UseMutationResult<
      CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
      OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
        TVariables,
        OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
        TContext
      >
    ): UseMutationResult<
      CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
      OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const cancelAppointmentEndpointAgentToolAppointmentCancelPostTotal = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const cancelAppointmentEndpointAgentToolAppointmentCancelPostTotal = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const cancelAppointmentEndpointAgentToolAppointmentCancelPostPendingMutationVariables = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const cancelAppointmentEndpointAgentToolAppointmentCancelPostMutationData = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
        OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
        MutationVariables<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
          CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
          OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
          MutationVariables<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
              OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
              OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
              TContext
            >
      ):
        | Mutation<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostError,
            MutationVariables<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
              OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
              OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
          CancelAppointmentEndpointAgentToolAppointmentCancelPostError,
          MutationVariables<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema;
    types: {
      parameters: CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters;
      data: CancelAppointmentEndpointAgentToolAppointmentCancelPostData;
      error: CancelAppointmentEndpointAgentToolAppointmentCancelPostError;
      body: CancelAppointmentEndpointAgentToolAppointmentCancelPostBody;
    };
  };
  /**
   * @summary Add Appointment Note Endpoint
   * @description Add a note to an appointment by appending to any existing notes.
   */
  addAppointmentNoteEndpointAgentToolAppointmentAddNotePost: {
    /**
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
        options: ServiceOperationMutationFnOptions<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError
      >
    >;
    /**
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     */
    getMutationKey(
      parameters: DeepReadonly<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters> | void
    ): ServiceOperationMutationKey<
      AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
      AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody, TContext = unknown>(
      parameters: DeepReadonly<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
        TVariables,
        OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
        TContext
      >
    ): UseMutationResult<
      AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
      OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
        TVariables,
        OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
        TContext
      >
    ): UseMutationResult<
      AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
      OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const addAppointmentNoteEndpointAgentToolAppointmentAddNotePostTotal = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const addAppointmentNoteEndpointAgentToolAppointmentAddNotePostTotal = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const addAppointmentNoteEndpointAgentToolAppointmentAddNotePostPendingMutationVariables = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const addAppointmentNoteEndpointAgentToolAppointmentAddNotePostMutationData = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
        OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
        MutationVariables<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
          OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
          MutationVariables<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
              OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
              OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
              TContext
            >
      ):
        | Mutation<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError,
            MutationVariables<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
              OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
              OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
              TContext
            >
      ): Array<
        Mutation<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError,
          MutationVariables<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
          >,
          TContext
        >
      >;
    };
    schema: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema;
    types: {
      parameters: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters;
      data: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData;
      error: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError;
      body: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody;
    };
  };
}
/** @summary Get Default */
export const getDefaultVoiceAgent = {
  schema: {
    method: 'get',
    url: '/agent/voice/default',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetDefaultVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentService['getDefaultVoiceAgent'];
};
/** @summary Create Default */
export const createDefaultVoiceAgent = {
  schema: {
    method: 'post',
    url: '/agent/voice/default',
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateDefaultVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentService['createDefaultVoiceAgent'];
};
/** @summary List Voice Agents */
export const listVoiceAgents = {
  schema: {
    method: 'get',
    url: '/agent/voice/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListVoiceAgentsSchema;
  [QraftServiceOperationsToken]: AgentService['listVoiceAgents'];
};
/** @summary Create */
export const createVoiceAgent = {
  schema: {
    method: 'post',
    url: '/agent/voice/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentService['createVoiceAgent'];
};
/** @summary Update */
export const updateVoiceAgent = {
  schema: {
    method: 'patch',
    url: '/agent/voice/{id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentService['updateVoiceAgent'];
};
/** @summary Build */
export const buildVoiceAgent = {
  schema: {
    method: 'get',
    url: '/agent/voice/{id}/build',
    security: ['HTTPBearer'],
  },
} as {
  schema: BuildVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentService['buildVoiceAgent'];
};
/** @summary Publish */
export const publishVoiceAgent = {
  schema: {
    method: 'post',
    url: '/agent/voice/{id}/publish',
    security: ['HTTPBearer'],
  },
} as {
  schema: PublishVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentService['publishVoiceAgent'];
};
/** @summary Sync With Config */
export const syncVoiceAgent = {
  schema: {
    method: 'post',
    url: '/agent/voice/{id}/sync-with-config',
    security: ['HTTPBearer'],
  },
} as {
  schema: SyncVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentService['syncVoiceAgent'];
};
/** @summary Start Call */
export const startTestCall = {
  schema: {
    method: 'post',
    url: '/agent/voice/{id}/start-call',
    security: ['HTTPBearer'],
  },
} as {
  schema: StartTestCallSchema;
  [QraftServiceOperationsToken]: AgentService['startTestCall'];
};
/** @summary List Voices */
export const listVoices = {
  schema: {
    method: 'get',
    url: '/agent/voice/voices',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListVoicesSchema;
  [QraftServiceOperationsToken]: AgentService['listVoices'];
};
/** @summary Run Sync */
export const runVoiceAgentSync = {
  schema: {
    method: 'post',
    url: '/agent/voice/run-sync',
    security: ['HTTPBearer'],
  },
} as {
  schema: RunVoiceAgentSyncSchema;
  [QraftServiceOperationsToken]: AgentService['runVoiceAgentSync'];
};
/** @summary List */
export const listAgentConfigs = {
  schema: {
    method: 'get',
    url: '/agent/configs/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListAgentConfigsSchema;
  [QraftServiceOperationsToken]: AgentService['listAgentConfigs'];
};
/** @summary Create */
export const createAgentConfig = {
  schema: {
    method: 'post',
    url: '/agent/configs/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateAgentConfigSchema;
  [QraftServiceOperationsToken]: AgentService['createAgentConfig'];
};
/** @summary Get */
export const getAgentConfig = {
  schema: {
    method: 'get',
    url: '/agent/configs/{agent_config_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAgentConfigSchema;
  [QraftServiceOperationsToken]: AgentService['getAgentConfig'];
};
/** @summary Update */
export const updateAgentConfig = {
  schema: {
    method: 'patch',
    url: '/agent/configs/{agent_config_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateAgentConfigSchema;
  [QraftServiceOperationsToken]: AgentService['updateAgentConfig'];
};
/** @summary List */
export const listBlocks = {
  schema: {
    method: 'get',
    url: '/agent/blocks/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListBlocksSchema;
  [QraftServiceOperationsToken]: AgentService['listBlocks'];
};
/** @summary Create */
export const createBlock = {
  schema: {
    method: 'post',
    url: '/agent/blocks/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateBlockSchema;
  [QraftServiceOperationsToken]: AgentService['createBlock'];
};
/** @summary Template Context */
export const getTemplateContext = {
  schema: {
    method: 'get',
    url: '/agent/blocks/template_context',
  },
} as {
  schema: GetTemplateContextSchema;
  [QraftServiceOperationsToken]: AgentService['getTemplateContext'];
};
/** @summary Preview */
export const previewBlock = {
  schema: {
    method: 'post',
    url: '/agent/blocks/preview',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: PreviewBlockSchema;
  [QraftServiceOperationsToken]: AgentService['previewBlock'];
};
/** @summary Update */
export const updateBlock = {
  schema: {
    method: 'patch',
    url: '/agent/blocks/{block_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateBlockSchema;
  [QraftServiceOperationsToken]: AgentService['updateBlock'];
};
/**
 * @summary Get Customers By Phone Endpoint
 * @description Get customers by phone number.
 *
 * Search for customers using their phone number. The phone number will be validated
 * and normalized to E164 format before searching.
 *
 * For testing in FastAPI docs:
 * 1. Ensure you have a valid retell_agent_id in the voice_agents table
 * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
 */
export const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/customer/get_by_phone',
    mediaType: ['application/json'],
  },
} as {
  schema: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema;
  [QraftServiceOperationsToken]: AgentService['getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost'];
};
/**
 * @summary Get Customers By Zipcode Endpoint
 * @description Get customers by zipcode.
 *
 * Search for all customers in a specific ZIP code area.
 */
export const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/customer/get_by_zipcode',
    mediaType: ['application/json'],
  },
} as {
  schema: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema;
  [QraftServiceOperationsToken]: AgentService['getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost'];
};
/**
 * @summary Search Customers By Address Endpoint
 * @description Search customers by address with fuzzy matching.
 *
 * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
 * Returns exact matches and similar addresses with similarity scores.
 */
export const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/customer/search_by_address',
    mediaType: ['application/json'],
  },
} as {
  schema: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema;
  [QraftServiceOperationsToken]: AgentService['searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost'];
};
/**
 * @summary Create Customer Endpoint
 * @description Create a new customer.
 *
 * Creates a new customer with contact information and optional address.
 */
export const createCustomerEndpointAgentToolCustomerCreatePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/customer/create',
    mediaType: ['application/json'],
  },
} as {
  schema: CreateCustomerEndpointAgentToolCustomerCreatePostSchema;
  [QraftServiceOperationsToken]: AgentService['createCustomerEndpointAgentToolCustomerCreatePost'];
};
/**
 * @summary Get Availability Endpoint
 * @description Get available appointment slots for a customer and service type.
 */
export const getAvailabilityEndpointAgentToolAvailabilityListPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/availability/list',
    mediaType: ['application/json'],
  },
} as {
  schema: GetAvailabilityEndpointAgentToolAvailabilityListPostSchema;
  [QraftServiceOperationsToken]: AgentService['getAvailabilityEndpointAgentToolAvailabilityListPost'];
};
/**
 * @summary List Appointments Endpoint
 * @description List appointments for a customer.
 */
export const listAppointmentsEndpointAgentToolAppointmentListPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/list',
    mediaType: ['application/json'],
  },
} as {
  schema: ListAppointmentsEndpointAgentToolAppointmentListPostSchema;
  [QraftServiceOperationsToken]: AgentService['listAppointmentsEndpointAgentToolAppointmentListPost'];
};
/**
 * @summary List Past Appointments Endpoint
 * @description List past appointments for a customer.
 */
export const listPastAppointmentsEndpointAgentToolAppointmentListPastPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/list_past',
    mediaType: ['application/json'],
  },
} as {
  schema: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema;
  [QraftServiceOperationsToken]: AgentService['listPastAppointmentsEndpointAgentToolAppointmentListPastPost'];
};
/**
 * @summary List Upcoming Appointments Endpoint
 * @description List upcoming appointments for a customer.
 */
export const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/list_upcoming',
    mediaType: ['application/json'],
  },
} as {
  schema: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema;
  [QraftServiceOperationsToken]: AgentService['listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost'];
};
/**
 * @summary Book Appointment Endpoint
 * @description Book a new appointment for a customer.
 */
export const bookAppointmentEndpointAgentToolAppointmentBookPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/book',
    mediaType: ['application/json'],
  },
} as {
  schema: BookAppointmentEndpointAgentToolAppointmentBookPostSchema;
  [QraftServiceOperationsToken]: AgentService['bookAppointmentEndpointAgentToolAppointmentBookPost'];
};
/**
 * @summary Reschedule Appointment Endpoint
 * @description Reschedule an existing appointment.
 */
export const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/reschedule',
    mediaType: ['application/json'],
  },
} as {
  schema: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema;
  [QraftServiceOperationsToken]: AgentService['rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost'];
};
/**
 * @summary Cancel Appointment Endpoint
 * @description Cancel an appointment.
 */
export const cancelAppointmentEndpointAgentToolAppointmentCancelPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/cancel',
    mediaType: ['application/json'],
  },
} as {
  schema: CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema;
  [QraftServiceOperationsToken]: AgentService['cancelAppointmentEndpointAgentToolAppointmentCancelPost'];
};
/**
 * @summary Add Appointment Note Endpoint
 * @description Add a note to an appointment by appending to any existing notes.
 */
export const addAppointmentNoteEndpointAgentToolAppointmentAddNotePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/add_note',
    mediaType: ['application/json'],
  },
} as {
  schema: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema;
  [QraftServiceOperationsToken]: AgentService['addAppointmentNoteEndpointAgentToolAppointmentAddNotePost'];
};
export const agentService = {
  getDefaultVoiceAgent,
  createDefaultVoiceAgent,
  listVoiceAgents,
  createVoiceAgent,
  updateVoiceAgent,
  buildVoiceAgent,
  publishVoiceAgent,
  syncVoiceAgent,
  startTestCall,
  listVoices,
  runVoiceAgentSync,
  listAgentConfigs,
  createAgentConfig,
  getAgentConfig,
  updateAgentConfig,
  listBlocks,
  createBlock,
  getTemplateContext,
  previewBlock,
  updateBlock,
  getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost,
  getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost,
  searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost,
  createCustomerEndpointAgentToolCustomerCreatePost,
  getAvailabilityEndpointAgentToolAvailabilityListPost,
  listAppointmentsEndpointAgentToolAppointmentListPost,
  listPastAppointmentsEndpointAgentToolAppointmentListPastPost,
  listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost,
  bookAppointmentEndpointAgentToolAppointmentBookPost,
  rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost,
  cancelAppointmentEndpointAgentToolAppointmentCancelPost,
  addAppointmentNoteEndpointAgentToolAppointmentAddNotePost,
} as const;
type GetDefaultVoiceAgentSchema = {
  method: 'get';
  url: '/agent/voice/default';
  security: ['HTTPBearer'];
};
type GetDefaultVoiceAgentParameters = undefined;
type GetDefaultVoiceAgentData = paths['/agent/voice/default']['get']['responses']['200']['content']['application/json'];
type GetDefaultVoiceAgentError = unknown;
type CreateDefaultVoiceAgentSchema = {
  method: 'post';
  url: '/agent/voice/default';
  security: ['HTTPBearer'];
};
type CreateDefaultVoiceAgentParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateDefaultVoiceAgentData =
  paths['/agent/voice/default']['post']['responses']['200']['content']['application/json'];
type CreateDefaultVoiceAgentError = unknown;
type CreateDefaultVoiceAgentBody = undefined;
type ListVoiceAgentsSchema = {
  method: 'get';
  url: '/agent/voice/';
  security: ['HTTPBearer'];
};
type ListVoiceAgentsParameters = undefined;
type ListVoiceAgentsData = paths['/agent/voice/']['get']['responses']['200']['content']['application/json'];
type ListVoiceAgentsError = unknown;
type CreateVoiceAgentSchema = {
  method: 'post';
  url: '/agent/voice/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateVoiceAgentParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateVoiceAgentData = paths['/agent/voice/']['post']['responses']['200']['content']['application/json'];
type CreateVoiceAgentError = paths['/agent/voice/']['post']['responses']['422']['content']['application/json'];
type CreateVoiceAgentBody = paths['/agent/voice/']['post']['requestBody']['content']['application/json'];
type UpdateVoiceAgentSchema = {
  method: 'patch';
  url: '/agent/voice/{id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateVoiceAgentParameters = paths['/agent/voice/{id}']['patch']['parameters'];
type UpdateVoiceAgentData = paths['/agent/voice/{id}']['patch']['responses']['200']['content']['application/json'];
type UpdateVoiceAgentError = paths['/agent/voice/{id}']['patch']['responses']['422']['content']['application/json'];
type UpdateVoiceAgentBody = paths['/agent/voice/{id}']['patch']['requestBody']['content']['application/json'];
type BuildVoiceAgentSchema = {
  method: 'get';
  url: '/agent/voice/{id}/build';
  security: ['HTTPBearer'];
};
type BuildVoiceAgentParameters = paths['/agent/voice/{id}/build']['get']['parameters'];
type BuildVoiceAgentData = paths['/agent/voice/{id}/build']['get']['responses']['200']['content']['application/json'];
type BuildVoiceAgentError = paths['/agent/voice/{id}/build']['get']['responses']['422']['content']['application/json'];
type PublishVoiceAgentSchema = {
  method: 'post';
  url: '/agent/voice/{id}/publish';
  security: ['HTTPBearer'];
};
type PublishVoiceAgentParameters = paths['/agent/voice/{id}/publish']['post']['parameters'];
type PublishVoiceAgentData =
  paths['/agent/voice/{id}/publish']['post']['responses']['200']['content']['application/json'];
type PublishVoiceAgentError =
  paths['/agent/voice/{id}/publish']['post']['responses']['422']['content']['application/json'];
type PublishVoiceAgentBody = undefined;
type SyncVoiceAgentSchema = {
  method: 'post';
  url: '/agent/voice/{id}/sync-with-config';
  security: ['HTTPBearer'];
};
type SyncVoiceAgentParameters = paths['/agent/voice/{id}/sync-with-config']['post']['parameters'];
type SyncVoiceAgentData =
  paths['/agent/voice/{id}/sync-with-config']['post']['responses']['200']['content']['application/json'];
type SyncVoiceAgentError =
  paths['/agent/voice/{id}/sync-with-config']['post']['responses']['422']['content']['application/json'];
type SyncVoiceAgentBody = undefined;
type StartTestCallSchema = {
  method: 'post';
  url: '/agent/voice/{id}/start-call';
  security: ['HTTPBearer'];
};
type StartTestCallParameters = paths['/agent/voice/{id}/start-call']['post']['parameters'];
type StartTestCallData =
  paths['/agent/voice/{id}/start-call']['post']['responses']['200']['content']['application/json'];
type StartTestCallError =
  paths['/agent/voice/{id}/start-call']['post']['responses']['422']['content']['application/json'];
type StartTestCallBody = undefined;
type ListVoicesSchema = {
  method: 'get';
  url: '/agent/voice/voices';
  security: ['HTTPBearer'];
};
type ListVoicesParameters = undefined;
type ListVoicesData = paths['/agent/voice/voices']['get']['responses']['200']['content']['application/json'];
type ListVoicesError = unknown;
type RunVoiceAgentSyncSchema = {
  method: 'post';
  url: '/agent/voice/run-sync';
  security: ['HTTPBearer'];
};
type RunVoiceAgentSyncParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type RunVoiceAgentSyncData = paths['/agent/voice/run-sync']['post']['responses']['200']['content']['application/json'];
type RunVoiceAgentSyncError = unknown;
type RunVoiceAgentSyncBody = undefined;
type ListAgentConfigsSchema = {
  method: 'get';
  url: '/agent/configs/';
  security: ['HTTPBearer'];
};
type ListAgentConfigsParameters = undefined;
type ListAgentConfigsData = paths['/agent/configs/']['get']['responses']['200']['content']['application/json'];
type ListAgentConfigsError = unknown;
type CreateAgentConfigSchema = {
  method: 'post';
  url: '/agent/configs/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateAgentConfigParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateAgentConfigData = paths['/agent/configs/']['post']['responses']['200']['content']['application/json'];
type CreateAgentConfigError = paths['/agent/configs/']['post']['responses']['422']['content']['application/json'];
type CreateAgentConfigBody = paths['/agent/configs/']['post']['requestBody']['content']['application/json'];
type GetAgentConfigSchema = {
  method: 'get';
  url: '/agent/configs/{agent_config_id}';
  security: ['HTTPBearer'];
};
type GetAgentConfigParameters = paths['/agent/configs/{agent_config_id}']['get']['parameters'];
type GetAgentConfigData =
  paths['/agent/configs/{agent_config_id}']['get']['responses']['200']['content']['application/json'];
type GetAgentConfigError =
  paths['/agent/configs/{agent_config_id}']['get']['responses']['422']['content']['application/json'];
type UpdateAgentConfigSchema = {
  method: 'patch';
  url: '/agent/configs/{agent_config_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateAgentConfigParameters = paths['/agent/configs/{agent_config_id}']['patch']['parameters'];
type UpdateAgentConfigData =
  paths['/agent/configs/{agent_config_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateAgentConfigError =
  paths['/agent/configs/{agent_config_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateAgentConfigBody =
  paths['/agent/configs/{agent_config_id}']['patch']['requestBody']['content']['application/json'];
type ListBlocksSchema = {
  method: 'get';
  url: '/agent/blocks/';
  security: ['HTTPBearer'];
};
type ListBlocksParameters = undefined;
type ListBlocksData = paths['/agent/blocks/']['get']['responses']['200']['content']['application/json'];
type ListBlocksError = unknown;
type CreateBlockSchema = {
  method: 'post';
  url: '/agent/blocks/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateBlockParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateBlockData = paths['/agent/blocks/']['post']['responses']['200']['content']['application/json'];
type CreateBlockError = paths['/agent/blocks/']['post']['responses']['422']['content']['application/json'];
type CreateBlockBody = paths['/agent/blocks/']['post']['requestBody']['content']['application/json'];
type GetTemplateContextSchema = {
  method: 'get';
  url: '/agent/blocks/template_context';
};
type GetTemplateContextParameters = undefined;
type GetTemplateContextData =
  paths['/agent/blocks/template_context']['get']['responses']['200']['content']['application/json'];
type GetTemplateContextError = unknown;
type PreviewBlockSchema = {
  method: 'post';
  url: '/agent/blocks/preview';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type PreviewBlockParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type PreviewBlockData = paths['/agent/blocks/preview']['post']['responses']['200']['content']['application/json'];
type PreviewBlockError = paths['/agent/blocks/preview']['post']['responses']['422']['content']['application/json'];
type PreviewBlockBody = paths['/agent/blocks/preview']['post']['requestBody']['content']['application/json'];
type UpdateBlockSchema = {
  method: 'patch';
  url: '/agent/blocks/{block_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateBlockParameters = paths['/agent/blocks/{block_id}']['patch']['parameters'];
type UpdateBlockData = paths['/agent/blocks/{block_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateBlockError = paths['/agent/blocks/{block_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateBlockBody = paths['/agent/blocks/{block_id}']['patch']['requestBody']['content']['application/json'];
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema = {
  method: 'post';
  url: '/agent/tool/customer/get_by_phone';
  mediaType: ['application/json'];
};
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData =
  paths['/agent/tool/customer/get_by_phone']['post']['responses']['200']['content']['application/json'];
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError =
  paths['/agent/tool/customer/get_by_phone']['post']['responses']['422']['content']['application/json'];
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody =
  paths['/agent/tool/customer/get_by_phone']['post']['requestBody']['content']['application/json'];
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema = {
  method: 'post';
  url: '/agent/tool/customer/get_by_zipcode';
  mediaType: ['application/json'];
};
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData =
  paths['/agent/tool/customer/get_by_zipcode']['post']['responses']['200']['content']['application/json'];
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError =
  paths['/agent/tool/customer/get_by_zipcode']['post']['responses']['422']['content']['application/json'];
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody =
  paths['/agent/tool/customer/get_by_zipcode']['post']['requestBody']['content']['application/json'];
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema = {
  method: 'post';
  url: '/agent/tool/customer/search_by_address';
  mediaType: ['application/json'];
};
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData =
  paths['/agent/tool/customer/search_by_address']['post']['responses']['200']['content']['application/json'];
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError =
  paths['/agent/tool/customer/search_by_address']['post']['responses']['422']['content']['application/json'];
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody =
  paths['/agent/tool/customer/search_by_address']['post']['requestBody']['content']['application/json'];
type CreateCustomerEndpointAgentToolCustomerCreatePostSchema = {
  method: 'post';
  url: '/agent/tool/customer/create';
  mediaType: ['application/json'];
};
type CreateCustomerEndpointAgentToolCustomerCreatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateCustomerEndpointAgentToolCustomerCreatePostData =
  paths['/agent/tool/customer/create']['post']['responses']['200']['content']['application/json'];
type CreateCustomerEndpointAgentToolCustomerCreatePostError =
  paths['/agent/tool/customer/create']['post']['responses']['422']['content']['application/json'];
type CreateCustomerEndpointAgentToolCustomerCreatePostBody =
  paths['/agent/tool/customer/create']['post']['requestBody']['content']['application/json'];
type GetAvailabilityEndpointAgentToolAvailabilityListPostSchema = {
  method: 'post';
  url: '/agent/tool/availability/list';
  mediaType: ['application/json'];
};
type GetAvailabilityEndpointAgentToolAvailabilityListPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type GetAvailabilityEndpointAgentToolAvailabilityListPostData =
  paths['/agent/tool/availability/list']['post']['responses']['200']['content']['application/json'];
type GetAvailabilityEndpointAgentToolAvailabilityListPostError =
  paths['/agent/tool/availability/list']['post']['responses']['422']['content']['application/json'];
type GetAvailabilityEndpointAgentToolAvailabilityListPostBody =
  paths['/agent/tool/availability/list']['post']['requestBody']['content']['application/json'];
type ListAppointmentsEndpointAgentToolAppointmentListPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/list';
  mediaType: ['application/json'];
};
type ListAppointmentsEndpointAgentToolAppointmentListPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ListAppointmentsEndpointAgentToolAppointmentListPostData =
  paths['/agent/tool/appointment/list']['post']['responses']['200']['content']['application/json'];
type ListAppointmentsEndpointAgentToolAppointmentListPostError =
  paths['/agent/tool/appointment/list']['post']['responses']['422']['content']['application/json'];
type ListAppointmentsEndpointAgentToolAppointmentListPostBody =
  paths['/agent/tool/appointment/list']['post']['requestBody']['content']['application/json'];
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/list_past';
  mediaType: ['application/json'];
};
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData =
  paths['/agent/tool/appointment/list_past']['post']['responses']['200']['content']['application/json'];
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError =
  paths['/agent/tool/appointment/list_past']['post']['responses']['422']['content']['application/json'];
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody =
  paths['/agent/tool/appointment/list_past']['post']['requestBody']['content']['application/json'];
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/list_upcoming';
  mediaType: ['application/json'];
};
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData =
  paths['/agent/tool/appointment/list_upcoming']['post']['responses']['200']['content']['application/json'];
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError =
  paths['/agent/tool/appointment/list_upcoming']['post']['responses']['422']['content']['application/json'];
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody =
  paths['/agent/tool/appointment/list_upcoming']['post']['requestBody']['content']['application/json'];
type BookAppointmentEndpointAgentToolAppointmentBookPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/book';
  mediaType: ['application/json'];
};
type BookAppointmentEndpointAgentToolAppointmentBookPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type BookAppointmentEndpointAgentToolAppointmentBookPostData =
  paths['/agent/tool/appointment/book']['post']['responses']['200']['content']['application/json'];
type BookAppointmentEndpointAgentToolAppointmentBookPostError =
  paths['/agent/tool/appointment/book']['post']['responses']['422']['content']['application/json'];
type BookAppointmentEndpointAgentToolAppointmentBookPostBody =
  paths['/agent/tool/appointment/book']['post']['requestBody']['content']['application/json'];
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/reschedule';
  mediaType: ['application/json'];
};
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData =
  paths['/agent/tool/appointment/reschedule']['post']['responses']['200']['content']['application/json'];
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError =
  paths['/agent/tool/appointment/reschedule']['post']['responses']['422']['content']['application/json'];
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody =
  paths['/agent/tool/appointment/reschedule']['post']['requestBody']['content']['application/json'];
type CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/cancel';
  mediaType: ['application/json'];
};
type CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CancelAppointmentEndpointAgentToolAppointmentCancelPostData =
  paths['/agent/tool/appointment/cancel']['post']['responses']['200']['content']['application/json'];
type CancelAppointmentEndpointAgentToolAppointmentCancelPostError =
  paths['/agent/tool/appointment/cancel']['post']['responses']['422']['content']['application/json'];
type CancelAppointmentEndpointAgentToolAppointmentCancelPostBody =
  paths['/agent/tool/appointment/cancel']['post']['requestBody']['content']['application/json'];
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/add_note';
  mediaType: ['application/json'];
};
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData =
  paths['/agent/tool/appointment/add_note']['post']['responses']['200']['content']['application/json'];
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError =
  paths['/agent/tool/appointment/add_note']['post']['responses']['422']['content']['application/json'];
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody =
  paths['/agent/tool/appointment/add_note']['post']['requestBody']['content']['application/json'];
